/* Culture Nest — theme JS. Uses Shopify Cart AJAX API. */
(function(){
  'use strict';
  var $ = function(s,c){return (c||document).querySelector(s);};
  var $$ = function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));};

  var CN = window.CN = window.CN || {};
  CN.money = function(cents){
    var v = (cents/100);
    var s = v.toLocaleString('en-IN',{maximumFractionDigits: v % 1 === 0 ? 0 : 2, minimumFractionDigits:0});
    return (window.CNSettings && CNSettings.currencySymbol ? CNSettings.currencySymbol : '₹') + s;
  };

  /* ---------- toast ---------- */
  var toastEl;
  CN.toast = function(msg){
    if(!toastEl){ toastEl = document.createElement('div'); toastEl.className='toast'; toastEl.setAttribute('role','status'); toastEl.setAttribute('aria-live','polite'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function(){ toastEl.classList.remove('show'); }, 2400);
  };
  /* Toast with one link (opens in a new tab so the bag and page stay put); stays
     up long enough to tap. */
  CN.toastAction = function(msg, label, href){
    CN.toast(msg);
    if(!href || !label) return;
    var a = document.createElement('a');
    a.className = 'toast-action'; a.href = href; a.target = '_blank'; a.rel = 'noopener'; a.textContent = label;
    toastEl.appendChild(document.createTextNode(' '));
    toastEl.appendChild(a);
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function(){ toastEl.classList.remove('show'); }, 9000);
  };
  /* When Shiprocket's checkout can't open, offer a WhatsApp order to the support
     number with what the shopper was buying (never Shopify's own checkout). */
  CN.waOrderHref = function(lines){
    var base = (window.CNSettings && window.CNSettings.supportWa) || 'https://wa.me/917439946469';
    var txt = 'Hi Culture Nest, checkout didn’t open for me. I’d like to order: ' + ((lines && lines.length) ? lines.join(', ') : 'the items in my bag');
    return base + (base.indexOf('?') > -1 ? '&' : '?') + 'text=' + encodeURIComponent(txt);
  };
  CN.cartLines = function(){
    return ((CN._lastCart && CN._lastCart.items) || []).map(function(it){
      return it.product_title + (it.variant_title && it.variant_title !== 'Default Title' ? ' (' + it.variant_title + ')' : '') + ' × ' + it.quantity;
    });
  };
  CN.checkoutFailed = function(lines){
    CN.toastAction(CN.srBlockedMsg, 'Order on WhatsApp', CN.waOrderHref(lines || CN.cartLines()));
  };
  CN.copyLink = function(val, okMsg){
    var done = function(){ CN.toast(okMsg || 'Link copied'); };
    if(navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(val).then(done, done); }
    else { var ta = document.createElement('textarea'); ta.value = val; ta.setAttribute('readonly',''); ta.style.position='absolute'; ta.style.left='-9999px'; document.body.appendChild(ta); ta.select(); try{ document.execCommand('copy'); }catch(e){} ta.remove(); done(); }
  };
  /* Same write, but the promise only resolves when the copy actually happened.
     CN.copyLink above fires its callback on both settle paths, which is fine
     for a toast and wrong for anything that renders a "Copied" state: a denied
     clipboard would confirm a copy that is not on the clipboard. */
  function execCopy(val){
    return new Promise(function(res, rej){
      var ta = document.createElement('textarea');
      ta.value = val; ta.setAttribute('readonly','');
      ta.style.position='absolute'; ta.style.left='-9999px';
      document.body.appendChild(ta); ta.select();
      var ok = false;
      try{ ok = document.execCommand('copy'); }catch(e){ ok = false; }
      ta.remove();
      if(ok) res(); else rej();
    });
  }
  CN.writeClipboard = function(val){
    /* A clipboard API that EXISTS can still refuse: insecure context, an
       iframe without the permission, Safari outside a user gesture. The
       missing-API case was already covered; a denied one rejected outright
       and left the caller with nothing to fall back on, so both routes now
       end at execCommand. Still only resolves on a copy that happened —
       execCopy rejects when execCommand reports failure. */
    if(navigator.clipboard && navigator.clipboard.writeText){
      return navigator.clipboard.writeText(val).catch(function(){ return execCopy(val); });
    }
    return execCopy(val);
  };

  /* ---------- wishlist (localStorage; full page in wishlist template) ---------- */
  CN.wishKey = 'cn-wishlist';
  CN.getWish = function(){ try{ return JSON.parse(localStorage.getItem(CN.wishKey)) || []; }catch(e){ return []; } };
  CN.toggleWish = function(id){
    var w = CN.getWish(), i = w.indexOf(id);
    if(i > -1) w.splice(i,1); else w.push(id);
    try{ localStorage.setItem(CN.wishKey, JSON.stringify(w)); }catch(e){}
    return i === -1;
  };
  /* ---------- recently viewed (localStorage; feeds the empty-cart upsell) ---------- */
  CN.recentKey = 'cn-recent';
  CN.getRecent = function(){ try{ return JSON.parse(localStorage.getItem(CN.recentKey)) || []; }catch(e){ return []; } };
  CN.recordView = function(p){
    if(!p || !p.handle) return;
    var list = CN.getRecent().filter(function(x){ return x.handle !== p.handle; });
    list.unshift({ id:p.id || null, handle:p.handle, title:p.title, image:p.image, price:p.price, url:p.url });
    list = list.slice(0, 12);
    try{ localStorage.setItem(CN.recentKey, JSON.stringify(list)); }catch(e){}
  };

  CN.syncWish = function(){
    var w = CN.getWish();
    $$('.js-wish').forEach(function(b){
      var on = w.indexOf(b.dataset.wish) > -1;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };

  /* ---------- quick view (Section Rendering API) ---------- */
  CN.openQV = function(){
    var m = $('#quickView'), s = $('#qvScrim');
    if(m){ m.classList.add('open'); m.setAttribute('aria-hidden','false'); }
    if(s) s.classList.add('open');
    document.body.style.overflow = 'hidden';
    /* Same pattern as CN.openCart: remember the opener, trap Tab inside the
       dialog, and focus the always-present close button rather than
       anything in #qvBody (which is still showing "Loading…" at this
       point — content arrives async in CN.loadQV). Without this, aria-modal
       claimed the dialog was modal while Tab kept cycling through the page
       behind it, and closing never returned focus anywhere in particular. */
    if(m){
      CN._qvReturn = document.activeElement;
      if(CN._qvUntrap) CN._qvUntrap();
      CN._qvUntrap = CN.trapFocus(m);
      var cl = m.querySelector('#qvClose'); if(cl) setTimeout(function(){ cl.focus(); }, 80);
    }
  };
  CN.closeQV = function(){
    var m = $('#quickView'), s = $('#qvScrim');
    if(m){ m.classList.remove('open'); m.setAttribute('aria-hidden','true'); }
    if(s) s.classList.remove('open');
    document.body.style.overflow = '';
    if(CN._qvUntrap){ CN._qvUntrap(); CN._qvUntrap = null; }
    if(CN._qvReturn && CN._qvReturn.focus){ CN._qvReturn.focus(); CN._qvReturn = null; }
  };
  CN.loadQV = function(handle){
    var body = $('#qvBody'); if(!body) return;
    body.innerHTML = '<div class="qv-loading">Loading…</div>';
    CN.openQV();
    fetch(window.Shopify.routes.root + 'products/' + handle + '?section_id=quick-view', {headers:{'Accept':'text/html'}})
      .then(function(r){ return r.text(); })
      .then(function(html){ body.innerHTML = html; CN.initQV(body); })
      .catch(function(){ body.innerHTML = '<div class="qv-loading">Could not load this product. <a href="' + window.Shopify.routes.root + 'products/' + handle + '">Open product page</a></div>'; });
  };
  CN.initQV = function(root){
    var vEl = root.querySelector('#qvVariants');
    var variants = vEl ? JSON.parse(vEl.textContent) : [];
    var addBtn = root.querySelector('#qvAdd');
    function currentOpts(){ var o = []; root.querySelectorAll('.opt-vals input:checked').forEach(function(i){ o[i.dataset.pos-1] = i.value; }); return o; }
    function findVariant(){ var o = currentOpts(); if(!o.length) return variants[0]; return variants.find(function(v){ return v.options.every(function(x,i){ return x === o[i]; }); }); }
    function update(){
      var v = findVariant(); if(!v) return;
      var pr = root.querySelector('#qvPrice'); if(pr) pr.textContent = CN.money(v.price);
      var stock = root.querySelector('#qvStock');
      if(addBtn){
        addBtn.dataset.id = v.id;
        if(v.available){ addBtn.disabled = false; addBtn.textContent = 'Add to Bag'; if(stock){ stock.textContent = 'In stock'; stock.className = 'qv-stock in'; } }
        else { addBtn.disabled = true; addBtn.textContent = 'Sold out'; if(stock){ stock.textContent = 'Out of stock'; stock.className = 'qv-stock out'; } }
      }
      if(v.featured_media){ var im = root.querySelector('#qvImg'); if(im) im.src = v.featured_media.preview_image.src.replace(/(\.[a-z]+)(\?|$)/i,'_800x$1$2'); }
    }
    root.querySelectorAll('.opt-vals input').forEach(function(i){ i.addEventListener('change', update); });
    root.querySelectorAll('.qv-thumbs button').forEach(function(b){
      b.addEventListener('click', function(){
        var im = root.querySelector('#qvImg'); if(im) im.src = b.dataset.src;
        root.querySelectorAll('.qv-thumbs button').forEach(function(x){ x.classList.remove('on'); });
        b.classList.add('on');
      });
    });
    update();
  };

  /* delegated: quick view open, quick-view add, wishlist toggle, close */
  document.addEventListener('click', function(e){
    var t = e.target;
    var qvOpen = t.closest && t.closest('.js-quickview');
    if(qvOpen){ e.preventDefault(); CN.loadQV(qvOpen.dataset.handle); return; }
    var qvAdd = t.closest && t.closest('.js-qv-add');
    if(qvAdd && !qvAdd.disabled){ e.preventDefault(); CN.addToCart(qvAdd.dataset.id, 1, CN.cartImgFor(qvAdd)); CN.closeQV(); return; }
    var wish = t.closest && t.closest('.js-wish');
    if(wish){
      e.preventDefault();
      var on = CN.toggleWish(wish.dataset.wish);
      wish.classList.toggle('on', on); wish.setAttribute('aria-pressed', on ? 'true' : 'false');
      CN.toast(on ? 'Saved to wishlist' : 'Removed from wishlist');
      if(document.getElementById('wishlistGrid')) CN.renderWishlist();
      return;
    }
    /* The "saved for later" list that used to live inside the cart drawer
       (move to bag / choose options / remove, via .js-wish-add/-choose/-remove)
       was dropped along with the rest of the old drawer — it isn't part of
       the reference mock, so it wasn't rebuilt. The standalone wishlist
       page above (#wishlistGrid, CN.renderWishlist/getWish/toggleWish) is
       untouched and still fully works. */
    var rc = t.closest && t.closest('.js-refer-copy');
    if(rc){
      e.preventDefault();
      var val = rc.dataset.copy || '';
      var done = function(){ CN.toast('Link copied'); var old = rc.textContent; rc.textContent = 'Copied ✓'; setTimeout(function(){ rc.textContent = old; }, 2000); };
      if(navigator.clipboard && navigator.clipboard.writeText){ navigator.clipboard.writeText(val).then(done, done); }
      else { var ta = document.createElement('textarea'); ta.value = val; ta.setAttribute('readonly',''); ta.style.position='absolute'; ta.style.left='-9999px'; document.body.appendChild(ta); ta.select(); try{ document.execCommand('copy'); }catch(err){} ta.remove(); done(); }
      return;
    }
    /* product share: Instagram (native share sheet, else copy) + copy link */
    var sig = t.closest && t.closest('.js-share-ig');
    if(sig){
      e.preventDefault();
      var igUrl = sig.dataset.url, igTitle = sig.dataset.title || document.title, igText = sig.dataset.text || igTitle;
      if(navigator.share){ navigator.share({title: igTitle, text: igText, url: igUrl}).catch(function(){}); }
      else { CN.copyLink(igUrl, 'Link copied — paste it into your Instagram story or DM'); }
      return;
    }
    /* Copy link confirms on the button itself rather than through a toast: on
       a long product page the toast sits at the bottom of the viewport, far
       from the control that was just pressed, and is easy to miss entirely.
       The status text keeps the announcement for screen readers. */
    var scp = t.closest && t.closest('.js-share-copy');
    if(scp){
      e.preventDefault();
      var scpSt = document.getElementById('shareCopyStatus');
      CN.writeClipboard(scp.dataset.url).then(function(){
        scp.classList.add('is-copied');
        if(scpSt) scpSt.textContent = 'Link copied';
        clearTimeout(scp._t);
        scp._t = setTimeout(function(){
          scp.classList.remove('is-copied');
          if(scpSt) scpSt.textContent = '';
        }, 2200);
      }, function(){
        CN.toast('Could not copy — select the address bar to copy the link');
      });
      return;
    }
    if(t.closest && (t.closest('#qvClose') || t.id === 'qvScrim')){ CN.closeQV(); }
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') CN.closeQV(); });
  /* wishlist page: fetch each saved product's card via Section Rendering */
  CN.renderWishlist = function(){
    var grid = document.getElementById('wishlistGrid'); if(!grid) return;
    var empty = document.getElementById('wishlistEmpty');
    var handles = CN.getWish();
    grid.innerHTML = '';
    if(!handles.length){ if(empty) empty.hidden = false; return; }
    if(empty) empty.hidden = true;
    /* One batch, inserted in wishlist order; a newer render (every toggle on
       this page re-runs it) makes an older one's results void (audit JSC-14). */
    var gen = CN._wishGen = (CN._wishGen || 0) + 1;
    Promise.all(handles.map(function(h){
      return fetch(window.Shopify.routes.root + 'products/' + encodeURIComponent(h) + '?section_id=wishlist-card')
        .then(function(r){ return r.ok ? r.text() : ''; })
        .catch(function(){ return ''; });
    })).then(function(htmls){
      if(gen !== CN._wishGen) return;
      htmls.forEach(function(html){
        if(!html) return;
        var d = document.createElement('div'); d.innerHTML = html.trim();
        var card = d.querySelector('.card') || d.firstElementChild;
        if(card) grid.appendChild(card);
      });
      CN.syncWish();
    });
  };

  /* ---------- cookie consent ---------- */
  CN.initCookie = function(){
    var bar = document.getElementById('cookieBar'); if(!bar) return;
    var choice; try{ choice = localStorage.getItem('cn-cookie-consent'); }catch(e){}
    /* Publish the bar's height as --cookie-h so the mobile nav can shorten
       itself by exactly that much. Without it the drawer runs to the viewport
       floor and its last rows sit under the consent bar — unreadable, and a
       tap there hits the banner instead of the link. */
    var setH = function(){
      var h = bar.hidden ? 0 : bar.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--cookie-h', h + 'px');
    };
    /* Shopify's Customer Privacy API isn't always loaded when the bar is
       clicked; without it the choice never reached Shopify and "Reject" was
       only a display flag. Load it on demand, and on later visits re-assert a
       stored choice if Shopify's state disagrees (audit JSC-18). */
    var withPrivacy = function(cb){
      var sh = window.Shopify;
      if(sh && sh.customerPrivacy){ cb(sh.customerPrivacy); return; }
      if(sh && typeof sh.loadFeatures === 'function'){
        sh.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function(err){
          if(!err && window.Shopify && window.Shopify.customerPrivacy) cb(window.Shopify.customerPrivacy);
        });
      }
    };
    var applyConsent = function(c){
      var allow = c === 'all';
      withPrivacy(function(cp){
        cp.setTrackingConsent({ marketing: allow, analytics: allow, preferences: allow, sale_of_data: allow }, function(){});
      });
    };
    if(choice){
      setH();
      /* At most once per session: where the store's privacy settings don't
         require consent for the visitor's region, Shopify accepts
         setTrackingConsent but keeps reporting "allowed", so an unguarded
         re-assert would fire on every page view. */
      try{ if(sessionStorage.getItem('cn-consent-sync')) return; sessionStorage.setItem('cn-consent-sync', '1'); }catch(e){}
      withPrivacy(function(cp){
        var now = typeof cp.analyticsProcessingAllowed === 'function' ? cp.analyticsProcessingAllowed() : null;
        if(typeof now === 'boolean' && now !== (choice === 'all')) applyConsent(choice);
      });
      return;
    }
    bar.hidden = false;
    setH();
    if(window.ResizeObserver){ new ResizeObserver(setH).observe(bar); }
    else { window.addEventListener('resize', setH); }
    bar.addEventListener('click', function(e){
      var b = e.target.closest('[data-cookie]'); if(!b) return;
      try{ localStorage.setItem('cn-cookie-consent', b.dataset.cookie); }catch(e){}
      /* Previously this only stored a display flag — "Reject" dismissed the
         bar but never actually told Shopify to stop tracking. Native Web
         Pixels (Meta/GA via the Shopify sales channels) read consent from
         Shopify's own Customer Privacy API, not from this theme's storage,
         so the real gate has to go through setTrackingConsent. "Accept all"
         opts into everything; "Reject non-essential" opts out of everything
         but the required/essential category, which Shopify always allows. */
      applyConsent(b.dataset.cookie);
      bar.style.transition = 'opacity .3s ease, transform .3s ease';
      bar.style.opacity = '0'; bar.style.transform = 'translateY(12px)';
      setTimeout(function(){ bar.hidden = true; setH(); }, 300);
    });
  };

  /* ---------- welcome popup ---------- */
  CN.initWelcome = function(){
    var pop = document.getElementById('welcomePop'); if(!pop) return;
    var scrim = document.getElementById('welcomeScrim');
    var untrap, returnFocus;
    /* Marked role="dialog" aria-modal="true" in the markup, but until now had
       none of the behavior that implies — no focus trap, no initial focus,
       no Escape, no focus restored on close. Every other overlay in the
       theme (cart drawer, Quick View, search) already does this; matching
       that pattern here, self-contained the same way Quick View's own
       Escape handling is (not routed through the shared cart/search one). */
    function open(){
      pop.hidden = false; if(scrim) scrim.hidden = false;
      requestAnimationFrame(function(){ pop.classList.add('open'); if(scrim) scrim.classList.add('open'); });
      returnFocus = document.activeElement;
      if(CN.trapFocus) untrap = CN.trapFocus(pop);
      var cl = document.getElementById('welcomeClose');
      if(cl) setTimeout(function(){ cl.focus(); }, 80);
    }
    function close(){
      pop.classList.remove('open'); if(scrim) scrim.classList.remove('open');
      if(untrap){ untrap(); untrap = null; }
      try{ localStorage.setItem('cn-welcome-seen','1'); }catch(e){}
      setTimeout(function(){
        pop.hidden = true; if(scrim) scrim.hidden = true;
        if(returnFocus && returnFocus.focus) returnFocus.focus();
      }, 350);
    }
    document.addEventListener('click', function(e){
      if(e.target.closest && (e.target.closest('#welcomeClose') || e.target.id === 'welcomeScrim')) close();
    });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && pop.classList.contains('open')) close();
    });
    if(pop.querySelector('.form-success')){ try{ localStorage.setItem('cn-welcome-seen','1'); }catch(e){} open(); return; }
    var seen; try{ seen = localStorage.getItem('cn-welcome-seen'); }catch(e){}
    if(seen) return;
    setTimeout(open, (parseInt(pop.dataset.delay,10) || 6) * 1000);
  };

  function cnReady(){ CN.syncWish(); CN.renderWishlist(); CN.initCookie(); CN.initWelcome(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cnReady);
  else cnReady();

  /* ---------- Microsoft Clarity tags (2026-10) ----------
     Clarity's app embed defines window.clarity (a command queue) early in the
     head, so calls are safe at any point; if it is blocked, this is a no-op.
     Clarity captures utm_source/campaign itself but not which ad was clicked,
     so the ad parameters are set as custom tags. They are kept for the
     browser session (first touch), so a shopper who moves on to the cart or
     another product is still attributed to the ad. Ad identifiers only —
     nothing personal (fbclid is deliberately left out). Product-page events
     (buy_now_tap, shiprocket_opened, …) are sent from main-product.liquid. */
  CN.clarity = function(){
    try{ if(typeof window.clarity === 'function') window.clarity.apply(window, arguments); }catch(e){}
  };
  (function(){
    var KEY = 'cnAdTouch';
    var names = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'ad_id', 'campaign_id'];
    var touch = null, i, v;
    if(window.URLSearchParams){
      var q = new URLSearchParams(window.location.search);
      for(i = 0; i < names.length; i++){
        v = q.get(names[i]);
        if(v){ touch = touch || {}; touch[names[i]] = String(v).slice(0, 120); }
      }
    }
    if(touch){ try{ sessionStorage.setItem(KEY, JSON.stringify(touch)); }catch(e){} }
    else { try{ touch = JSON.parse(sessionStorage.getItem(KEY) || 'null'); }catch(e){ touch = null; } }
    if(!touch) return;
    for(var k in touch){ if(Object.prototype.hasOwnProperty.call(touch, k)) CN.clarity('set', k, touch[k]); }
  })();
  /* Cart drawer checkout (Shiprocket's injected button, or the native one
     before it renders). Capture phase: Shiprocket's own handler may stop
     propagation. */
  document.addEventListener('click', function(e){
    if(!e.target.closest) return;
    if(e.target.closest('#cartDrawer .sr-headless-checkout, #cartDrawer .ccart-checkout')){
      CN.clarity('set', 'buy_now_from', 'drawer');
      CN.clarity('event', 'buy_now_tap');
    }
  }, true);

  /* ---------- focus trap (reusable) ---------- */
  /* Keeps Tab focus inside a modal container. Queries on each Tab so it works
     with content rendered after open (e.g. the async cart body). */
  CN.trapFocus = function(container){
    function onKey(e){
      if(e.key !== 'Tab') return;
      var sel = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
      var f = Array.prototype.filter.call(container.querySelectorAll(sel), function(el){ return el.offsetParent !== null; });
      if(!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    return function(){ container.removeEventListener('keydown', onKey); };
  };

  /* ---------- cart drawer ---------- */
  var drawer, scrim;
  /* Renders the MRP-savings summary only once it's actually needed: the
     drawer is open and the cart has changed since the last time it ran.
     Called from both renderCart (cart just changed, drawer may already be
     open) and openCart (drawer just opened, cart may have changed since the
     last render) — whichever happens second is what actually triggers it. */
  CN._maybeRenderSummary = function(){
    if(!CN._summaryStale || !CN._lastCart) return;
    if(!drawer || !drawer.classList.contains('open')) return;
    CN._summaryStale = false;
    CN.renderSummary(CN._lastCart);
  };
  CN.openCart = function(){
    drawer = drawer || $('#cartDrawer'); scrim = scrim || $('#cartScrim');   /* may run before DOMContentLoaded */
    drawer&&drawer.classList.add('open'); scrim&&scrim.classList.add('open'); document.body.style.overflow='hidden';
    if(drawer){
      CN._cartReturn = document.activeElement;                 /* remember opener */
      if(CN._cartUntrap) CN._cartUntrap();
      CN._cartUntrap = CN.trapFocus(drawer);                   /* trap Tab inside */
      var cl = drawer.querySelector('#cartClose'); if(cl) setTimeout(function(){ cl.focus(); }, 80); /* focus into dialog */
    }
    CN._maybeRenderSummary();
    CN.paintCartEta();
    if(CN._celebratePending) setTimeout(function(){ if(CN._shipDone) CN.celebrate(); else CN._celebratePending = false; }, 450);
  };
  CN.closeCart = function(){
    drawer&&drawer.classList.remove('open'); scrim&&scrim.classList.remove('open'); document.body.style.overflow='';
    if(CN._cartUntrap){ CN._cartUntrap(); CN._cartUntrap = null; }
    if(CN._cartReturn && CN._cartReturn.focus){ CN._cartReturn.focus(); CN._cartReturn = null; } /* restore focus */
  };

  CN.renderCart = function(cart){
    var body = $('#cartBody'), foot = $('#cartFoot');
    var countEls = $$('.js-cart-count');
    countEls.forEach(function(el){
      el.textContent = cart.item_count;
      el.style.display = cart.item_count ? 'grid' : 'none';
    });
    var head = $('#cartHeadCount'); if(head) head.textContent = 'Cart' + (cart.item_count ? ' (' + cart.item_count + ')' : '');

    CN.renderCartOffer(cart);
    CN.syncDiscountCookie(cart);
    CN._dropPrepaidCode(cart);
    CN.renderCartCoupon(cart);
    CN.renderShipBar(cart);

    if(!body) return;
    var cc = $('#cartCoupon');
    if(!cart.item_count){
      if(foot) foot.hidden = true;
      /* Coupon isn't shown on an empty bag — matches the reference mock,
         which gates it behind hasItems too. */
      if(cc) cc.hidden = true;
      /* While a WhatsApp link rebuilds the bag (CN.restoreCartFromLink) the bag is empty for a moment: say so
         honestly instead of showing "Your cart is waiting" and a browse link, which looked like a glitch. */
      body.innerHTML = CN._silentRestore
        ? '<div class="ccart-empty"><h3>Getting your bag ready…</h3></div>'
        : '<div class="ccart-empty">'+
        '<h3>Your cart is waiting</h3>'+
        '<p>Discover home, kitchen and tech essentials picked for Indian homes.</p>'+
        '<a href="#drawerRecs">Browse recommendations &rarr;</a>'+
      '</div>';
      /* Keep the snapshot true when the bag empties — PDP Buy Now's fallback
         reads CN._lastCart and used to see the last NON-empty cart (JSC-07). */
      CN._lastCart = cart;
      CN._summaryStale = false;
      return;
    }
    if(cc) cc.hidden = false;
    /* key/url/img escaped too (audit SEC-16) — they come from /cart.js, not the template. */
    body.innerHTML = cart.items.map(function(it){
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i,'_160x$1$2') : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      return '<div class="ccart-item" data-key="'+cnEsc(it.key)+'">'+
        '<a class="ccart-item-img" href="'+cnEsc(it.url)+'">'+(img?'<img src="'+cnEsc(img)+'" alt="" loading="lazy" width="64" height="64">':'')+
          '<span class="ccart-badge" data-role="badge" hidden></span></a>'+
        '<div class="ccart-item-body">'+
          '<div class="ccart-item-top">'+
            '<a class="ccart-item-name" href="'+cnEsc(it.url)+'">'+cnEsc(it.product_title)+'</a>'+
            '<button type="button" class="ccart-item-remove rm js-qty" data-key="'+cnEsc(it.key)+'" data-q="0" aria-label="Remove '+cnEsc(it.product_title)+' from cart">&times;</button>'+
          '</div>'+
          (variant ? '<div class="ccart-item-variant">'+cnEsc(variant)+'</div>' : '')+
          /* Unit price and stepper share one row. The line total only earns a line of
             its own when it differs from the unit price (quantity above 1). */
          '<div class="ccart-item-bottom">'+
            '<div class="ccart-item-price"><b>'+CN.money(it.price)+'</b><s class="ccart-item-mrp" data-role="mrp" hidden></s>'+
              (it.quantity > 1 ? '<span class="ccart-linetotal">'+CN.money(it.final_line_price)+' for '+it.quantity+'</span>' : '')+
            '</div>'+
            '<div class="ccart-qty">'+
              '<button type="button" class="js-qty" data-key="'+cnEsc(it.key)+'" data-delta="-1" aria-label="Decrease quantity">&minus;</button>'+
              '<span>'+it.quantity+'</span>'+
              '<button type="button" class="js-qty" data-key="'+cnEsc(it.key)+'" data-delta="1" aria-label="Increase quantity">+</button>'+
            '</div>'+
          '</div>'+
          '<div class="ccart-item-eta" data-role="eta" hidden></div>'+
        '</div></div>';
    }).join('');
    CN._etaWeight = cart.total_weight || 0;
    if(drawer && drawer.classList.contains('open')) CN.paintCartEta();
    if(foot){
      foot.hidden = false;
      /* Deferred to drawer-open (CN._maybeRenderSummary) rather than run on
         every cart render — the shopper can't see the breakdown until the
         drawer is actually open anyway. */
      CN._lastCart = cart;
      CN._summaryStale = true;
      CN._maybeRenderSummary();
    }
  };

  /* ---------- free-shipping progress bar ----------
     Compares the cart subtotal (after product discounts, before any coupon) with
     settings.free_shipping_threshold — passed to the page in paise as
     CNSettings.freeShipThreshold. Below it: "Add ₹X more to get free shipping" and a
     partly filled bar; at or above: the unlocked message and a full, green bar. A
     threshold of 0 hides the bar. */
  CN.renderShipBar = function(cart){
    var el = $('#cartShip');
    if(!el) return;
    var thr = Number((window.CNSettings || {}).freeShipThreshold) || 0;
    if(!thr){ el.hidden = true; return; }
    if(!cart.item_count){ el.hidden = true; CN._shipDone = false; return; }   /* empty = a known "not yet" */
    var sub = cart.items_subtotal_price || 0, left = thr - sub, done = left <= 0;
    /* Celebrate only on a real crossing — from a known "below" to "at or above". The first
       render after page load just records where the cart already is. */
    var crossed = done && CN._shipDone === false;
    CN._shipDone = done;
    var pct = done ? 100 : Math.max(4, Math.min(100, Math.floor(sub / thr * 100)));
    var msg = $('#cartShipMsg'), fill = $('#cartShipFill'), track = $('#cartShipTrack');
    if(msg) msg.innerHTML = done
      ? "Congrats! You've unlocked <b>free shipping</b>"
      : 'Add <b>' + CN.money(left) + '</b> more to get <b>free shipping</b>';
    if(fill) fill.style.width = pct + '%';
    if(track) track.setAttribute('aria-valuenow', pct);
    el.classList.toggle('is-done', done);
    el.hidden = false;
    if(crossed){
      el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop');
      CN.celebrate();
    }
  };

  /* Confetti burst from the free-shipping bar, inside the drawer. Waits for the drawer to be
     open (it slides in over .45s) so it's actually seen; skipped for reduced-motion users. */
  CN.celebrate = function(){
    if(CN._silentRestore){ CN._celebratePending = false; return; }   /* WhatsApp link: straight on to checkout, no confetti */
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if(!drawer || !drawer.animate) return;
    if(!drawer.classList.contains('open')){ CN._celebratePending = true; return; }
    CN._celebratePending = false;
    var old = drawer.querySelector('.ccart-confetti'); if(old) old.remove();
    var box = document.createElement('div');
    box.className = 'ccart-confetti';
    box.setAttribute('aria-hidden', 'true');
    drawer.appendChild(box);
    var dr = drawer.getBoundingClientRect(), bar = $('#cartShip'), br = bar ? bar.getBoundingClientRect() : null;
    var ox = dr.width / 2, oy = br ? (br.top - dr.top + br.height / 2) : dr.height * 0.25;
    var colors = ['#C96A3A', '#20262B', '#71845B', '#E0976F', '#106B31', '#F2C14E'];
    var longest = 0;
    for(var i = 0; i < 46; i++){
      var p = document.createElement('i'), size = 6 + Math.random() * 6, round = Math.random() < 0.3;
      p.style.width = size + 'px';
      p.style.height = (round ? size : size * 1.6) + 'px';
      p.style.borderRadius = round ? '50%' : '2px';
      p.style.background = colors[i % colors.length];
      var dx = (Math.random() - 0.5) * dr.width * 0.95, up = 60 + Math.random() * 130,
          fall = dr.height - oy + 40, rot = (Math.random() - 0.5) * 900,
          dur = 1500 + Math.random() * 1100, delay = Math.random() * 180;
      p.animate([
        { transform: 'translate(' + ox + 'px,' + oy + 'px) rotate(0deg)', opacity: 1, easing: 'cubic-bezier(.15,.7,.3,1)' },
        { transform: 'translate(' + (ox + dx * 0.6) + 'px,' + (oy - up) + 'px) rotate(' + rot * 0.4 + 'deg)', opacity: 1, offset: 0.3, easing: 'cubic-bezier(.5,0,.9,.6)' },
        { transform: 'translate(' + (ox + dx) + 'px,' + (oy + fall) + 'px) rotate(' + rot + 'deg)', opacity: 0.9 }
      ], { duration: dur, delay: delay, fill: 'both' });
      box.appendChild(p);
      if(dur + delay > longest) longest = dur + delay;
    }
    setTimeout(function(){ if(box.parentNode) box.remove(); }, longest + 150);
  };

  /* ---------- "Delivery by …" on each cart line ----------
     Once a pincode has been checked on a product page (saved as 'cn-pincode'),
     every cart line (drawer cards and the /cart page rows — anything with
     data-role="eta") shows the same estimated delivery date. One date for the
     whole cart, because it all ships as one parcel: the courier's days for that
     pincode at the cart's total weight (Worker /delivery-estimate → Shiprocket),
     from the next dispatch day (same cutoff / Sunday / holiday rules as the
     product page), plus the same buffer. Runs only when the drawer opens or
     re-renders while open, so browsing never calls the Worker for it. Quiet on
     any failure or undeliverable pincode — those all just show nothing. */
  CN._etaCache = CN._etaCache || {};
  CN._etaBusy = CN._etaBusy || {};
  CN._etaDate = function(days, cfg){
    var IST = 330 * 60000, DAY = 864e5, cutH = Number(cfg.cutoff) || 14, buf = Number(cfg.buffer) || 0;
    var hol = (cfg.holidays || []).map(function(s){ return String(s).trim(); }).filter(Boolean);
    var dayOf = function(t){ return Math.floor(t / DAY) * DAY; };
    var work = function(t){ return new Date(t).getUTCDay() !== 0 && hol.indexOf(new Date(t).toISOString().slice(0, 10)) < 0; };
    var now = Date.now() + IST, today = dayOf(now), day = today;
    if(!(work(today) && now < today + cutH * 3600e3)){ day = today + DAY; while(!work(day)) day += DAY; }
    var t = day + (Number(days) + buf) * DAY;
    if(new Date(t).getUTCDay() === 0) t += DAY;                 /* no Sunday delivery dates */
    var d = new Date(t);
    return ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][d.getUTCDay()] + ', ' + d.getUTCDate() + ' ' +
      ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][d.getUTCMonth()];
  };
  CN.paintCartEta = function(){
    var els = $$('[data-role="eta"]');
    if(!els.length) return;
    var cfg = null, pin = null;
    try{ var ce = document.getElementById('cartDeliveryCfg'); cfg = ce ? JSON.parse(ce.textContent) : null; }catch(e){}
    try{ pin = localStorage.getItem('cn-pincode'); }catch(e){}
    if(!cfg || !cfg.api || !pin || !/^[1-9][0-9]{5}$/.test(pin)){
      els.forEach(function(el){ el.hidden = true; });
      return;
    }
    var kg = Math.max(0.5, (CN._etaWeight || 0) / 1000);
    var key = pin + '|' + (Math.ceil(kg * 2) / 2);
    var apply = function(res){
      $$('[data-role="eta"]').forEach(function(el){
        /* Only a pincode we can actually deliver to gets a date; an undeliverable
           or unknown one shows nothing (the product page already says so). */
        if(!res || !res.serviceable){ el.hidden = true; return; }
        el.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7" cy="17" r="1.8"/><circle cx="17.5" cy="17" r="1.8"/></svg>' +
          'Delivery by <b>' + CN._etaDate(res.days, cfg) + '</b>';
        el.hidden = false;
      });
    };
    if(CN._etaCache[key]){ apply(CN._etaCache[key]); return; }
    if(CN._etaBusy[key]) return;
    CN._etaBusy[key] = true;
    fetch(cfg.api + (cfg.api.indexOf('?') > -1 ? '&' : '?') + 'pin=' + pin + '&w=' + kg, { headers: { Accept: 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(res){
        if(!res || !res.ok || typeof res.serviceable !== 'boolean' || (res.serviceable && !(Number(res.days) >= 0))) return null;
        return { serviceable: res.serviceable, days: Number(res.days) };
      })
      .catch(function(){ return null; })
      .then(function(r){
        CN._etaBusy[key] = false;
        if(r) CN._etaCache[key] = r;
        apply(r);
      });
  };

  /* Written as an if/reassign, not `s==null?'':s` — Shopify's CDN-side asset
     minification (the stored file has the ternary; the served, versioned
     /cdn/shop/t/12/assets/theme.js does not) rewrites that exact shape into
     `s??""`, a syntax modern engines accept but a real slice of Meta's
     in-app-browser traffic doesn't: it throws "Unexpected token ?" while
     parsing this file, so `window.CN` never gets assigned at all — which is
     what turned every later `CN.x` call, including main-product.liquid's
     `window.CN.addToCart(...)` on Add to Bag, into a silent
     "Cannot read properties of undefined" (confirmed: 2 Clarity sessions,
     both fbclid/l.facebook.com referrers on deep-tissue-massage-gun,
     04-09 Sep 2026, 0 of 2 completed an Add to Cart). This shape doesn't
     give the minifier anything to fold into `??`. */
  function cnEsc(s){ if(s==null){ s=''; } return String(s).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  /* ---------- cart offer (single verified promo row, above checkout) ----------
     Reads its own config off #cartOffer's data-* attributes (rendered from
     settings.cart_offer_* — see snippets/cart-drawer.liquid). Absent entirely
     when the offer isn't both Enabled and Verified — see the two-gate
     comment there. */
  CN.renderCartOffer = function(cart){
    var el = $('#cartOffer'); if(!el) return;
    var min = parseInt(el.dataset.min, 10) || 0;
    var subtotal = cart.items_subtotal_price;
    var available = subtotal >= min;
    el.classList.toggle('is-available', available);
    el.classList.toggle('is-locked', !available);
    /* Below threshold, the code would just be rejected/ignored at checkout —
       disable the one-tap apply rather than let it look like it worked. */
    var fillBtn = $('#coFillBtn');
    if(fillBtn) fillBtn.disabled = !available;
  };

  /* ---------- hand the applied coupon to Shiprocket's checkout ----------
     Shiprocket (Fastrr) builds its own checkout session from the cart, and its
     script (channels/shopify.js) takes a coupon from exactly one place: the
     Shopify `discount_code` cookie (couponCodeCookie: ... getCookie("discount_code")).
     Shopify sets that cookie on its /discount/CODE route, but NOT when a code is
     applied through /cart/update.js — which is how this theme's cart applies
     one. So a coupon shown "Applied" in the bag opened Shiprocket's checkout
     with no coupon (its frame URL carried no couponCodeCookie at all). This
     mirrors the cart's applied code into that cookie; renderCart calls it on
     every cart update, so it also re-sets after the cookie expires while the
     bag still holds the code. It only ever SETS: clearing happens on an
     explicit Remove (below), never because a cart happens to show no discount,
     or a shopper arriving via a /discount/CODE link would lose the code Shopify
     just stored. Only real discount codes are mirrored, not automatic ones.
     The cookie holds ONE code. Codes Shiprocket applies by itself (an
     automatic discount there — FESTIVE100, checked in its dashboard
     2026-10-06; theme setting "Codes Shiprocket applies by itself") are
     never sent: Shiprocket adds those on its own, so the cookie carries the
     shopper's OTHER code, which Shiprocket combines with it.
     Among the rest, the one saving the most wins. `mayClear` (an explicit
     apply/remove) also clears a cookie left with nothing to send.
     The prepaid offer (PAYONLINE, CNSettings.prepaidAutoCode) is automatic in
     Shiprocket too, but only when the shopper pays online (owner, 2026-10-14):
     it is never sent, and a cookie still holding it from an older visit is
     cleared, so Shiprocket alone decides it by payment method. */
  CN._prepaidAutoCode = function(){
    return String((window.CNSettings || {}).prepaidAutoCode || '').trim().toLowerCase();
  };
  CN._shiprocketAutoCodes = function(){
    return String((window.CNSettings || {}).shiprocketAutoCodes || '').split(',').concat(CN._prepaidAutoCode())
      .map(function(s){ return s.trim().toLowerCase(); }).filter(Boolean);
  };
  CN.syncDiscountCookie = function(cart, mayClear){
    try{
      if(!cart) return;
      var auto = CN._shiprocketAutoCodes(), prepaid = CN._prepaidAutoCode();
      var m = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
      var cur = m ? decodeURIComponent(m[1]) : '';
      if(prepaid && cur.toLowerCase() === prepaid){ CN.clearDiscountCookie(); cur = ''; }
      var codes = CN.cartCodes(cart).filter(function(c){ return auto.indexOf(c.code.toLowerCase()) < 0; });
      if(!codes.length){ if(mayClear) CN.clearDiscountCookie(); return; }
      var best = codes.slice().sort(function(a, b){ return b.saved - a.saved; })[0];
      if(cur.toLowerCase() === best.code.toLowerCase()) return;
      /* A code that arrived on a WhatsApp reminder link (CNSettings.linkCodes, set in <head>) outranks whatever the
         bag holds; only an explicit apply/remove (mayClear) may replace it. */
      var linkCodes = String((window.CNSettings || {}).linkCodes || '').toLowerCase().split(',').filter(Boolean);
      if(!mayClear && cur && linkCodes.indexOf(cur.toLowerCase()) > -1) return;
      document.cookie = 'discount_code=' + encodeURIComponent(best.code) + '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    }catch(e){}
  };
  CN.clearDiscountCookie = function(){
    try{ document.cookie = 'discount_code=; path=/; max-age=0; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); }catch(e){}
  };

  /* Codes that are really working on this cart, with what each one saves.
     An order code (PAYONLINE) shows up in cart_level_discount_applications;
     a product code (FESTIVE100 — only on some products) shows up on the
     lines instead (line_level_discount_allocations), which the drawer used
     to miss entirely. cart.discount_codes lists every code entered, with
     `applicable` false for one that doesn't apply (yet). Two codes can sit
     on one cart when their Shopify combine settings allow it. */
  CN.cartCodes = function(cart){
    var saved = {}, titles = {}, seen = [];
    var add = function(title, amount){
      var k = String(title || '').toLowerCase(); if(!k) return;
      if(!(k in saved)){ saved[k] = 0; titles[k] = title; seen.push(title); }
      saved[k] += Number(amount) || 0;
    };
    /* /cart.js gives {type, title, total_allocated_amount}; the cart returned by
       /cart/change.js and /cart/update.js gives {amount, discount_application:{type, title}}.
       Reading only the first shape made every +/−/remove show "You saved ₹0". */
    ((cart && cart.cart_level_discount_applications) || []).forEach(function(d){
      if(!d) return;
      var app = d.discount_application || d;
      var amt = d.total_allocated_amount != null ? d.total_allocated_amount
              : (d.amount != null ? d.amount : app.total_allocated_amount);
      if(!app.type || app.type === 'discount_code') add(app.title, amt);
    });
    ((cart && cart.items) || []).forEach(function(it){
      (it.line_level_discount_allocations || []).forEach(function(a){
        var d = (a && a.discount_application) || {};
        if(d.type === 'discount_code') add(d.title, a.amount);
      });
    });
    var list = (cart && cart.discount_codes)
      ? cart.discount_codes.filter(function(c){ return c && c.applicable && c.code; }).map(function(c){ return c.code; })
      : seen;
    return list.map(function(code){
      var k = String(code).toLowerCase();
      return { code: titles[k] || code, saved: saved[k] || 0 };
    });
  };
  /* Product-level code savings — already taken out of items_subtotal_price,
     so the summary adds them back to show "before coupons" consistently. */
  CN._lineCodeDiscount = function(cart){
    var sum = 0;
    ((cart && cart.items) || []).forEach(function(it){
      (it.line_level_discount_allocations || []).forEach(function(a){
        if(a && a.discount_application && a.discount_application.type === 'discount_code') sum += Number(a.amount) || 0;
      });
    });
    return sum;
  };

  /* ---------- applied coupon (mirrors main-cart.liquid's server-rendered
     cart.cart_level_discount_applications, but reactive). Matches the mock's
     exact applied-state layout: code + "Applied ✓" / "You saved ₹X" on their
     own two lines, a separate underlined "Remove" text button alongside —
     and, since the mock treats "applied" and "enter a code" as mutually
     exclusive states (not both visible together), toggles the input form's
     visibility here too. ---------- */
  CN.renderCartCoupon = function(cart){
    var wrap = $('#cartCouponApplied'), form = $('#cartCouponForm'); if(!wrap) return;
    var codes = CN.cartCodes(cart);
    /* Codes can stack (FESTIVE100 + PAYONLINE), so one applied code leaves
       the form in place for a second; with two on, it steps aside. The
       one-tap offer row hides once its own code is already on. */
    if(form) form.hidden = codes.length >= 2;
    var hint = form && form.querySelector('.ccart-coupon-hint');
    if(hint) hint.textContent = codes.length ? 'Add another code' : 'Enter a coupon';
    var offer = $('#cartOffer'), offerToggle = $('#coToggle');
    if(offer){
      var offerOn = codes.some(function(c){ return c.code.toLowerCase() === String(offer.dataset.code || '').toLowerCase(); });
      offer.hidden = offerOn;
      if(offerToggle) offerToggle.hidden = offerOn;
    }
    if(!codes.length){ wrap.hidden = true; wrap.innerHTML = ''; return; }
    wrap.hidden = false;
    wrap.innerHTML = codes.map(function(c){
      return '<div class="ccart-coupon-row2">' +
        '<div>' +
          '<div class="ccart-coupon-code">' + cnEsc(c.code) + ' <span class="ccart-coupon-ok">Applied &#10003;</span></div>' +
          '<div class="ccart-coupon-saved">You saved ' + CN.money(c.saved) + '</div>' +
        '</div>' +
        '<button type="button" class="ccart-coupon-remove" data-code="' + cnEsc(c.code) + '" aria-label="Remove ' + cnEsc(c.code) + '">Remove</button>' +
      '</div>';
    }).join('');
  };

  /* Both apply and remove go through /cart/update.js's `discount` field —
     confirmed against this store: POSTing a code applies it (or silently
     no-ops with cart_level_discount_applications still empty if the code
     doesn't exist/qualify — no error, no HTTP failure, so "did it actually
     land" has to be read back off the refetched cart, same check either
     way), POSTing an empty string clears whatever's applied. This used to
     redirect through the native /discount/{code} route instead — a full
     navigation off the page (and out of the cart drawer specifically, into
     the standalone /cart page) just to set a cookie, needing a
     sessionStorage relay to still be able to toast success/failure once it
     landed back. Applying from inside the drawer should apply inside the
     drawer, the same fetch-then-refetch flow as every other reactive cart
     action (CN.changeQty, CN.removeDiscountCode, …). */
  /* Resolves with `matched` (true/false) so callers can react — e.g. clear
     the input once the code has actually landed, not just been submitted. */
  /* `discount` REPLACES every code on the cart, so a second code is sent
     together with the ones already working (comma-separated — Shopify's
     format). Afterwards, any entered code that isn't applying (an invalid
     one, or one that can't combine with the rest) is dropped again so the
     cart only ever holds codes that are really saving something. */
  CN._cartJson = function(){
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', {headers:{'Accept':'application/json'}}).then(function(r){ return r.json(); });
  };
  CN._setCodes = function(codes){
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart/update.js', {
      method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({discount: codes.join(',')})
    }).then(function(r){ return r.json(); });
  };
  CN.applyDiscountCode = function(code, opts){
    var quiet = !!(opts && opts.quiet);      /* quiet: no success toast (a failure is always reported) */
    code = (code || '').trim();
    if(!code) return Promise.resolve(false);
    var key = code.toLowerCase(), before = [];
    /* The prepaid offer needs no code: Shiprocket applies it when the shopper pays online. Typed, pasted
       from the PDP ticket or carried on a WhatsApp link, it is not put on the bag; resolves 'auto'
       (truthy, so the coupon input clears as on a success). */
    if(key === CN._prepaidAutoCode()){
      if(!quiet) CN.toast('No need to enter ' + code.toUpperCase() + ' — it’s applied automatically at checkout when you pay online');
      return Promise.resolve('auto');
    }
    return CN._cartJson()
      .then(function(cart){
        before = CN.cartCodes(cart).map(function(c){ return c.code; }).filter(function(c){ return c.toLowerCase() !== key; });
        return CN._setCodes(before.concat(code));
      })
      .then(function(cart){
        var now = CN.cartCodes(cart).map(function(c){ return c.code; });
        var has = now.map(function(c){ return c.toLowerCase(); });
        var matched = has.indexOf(key) > -1;
        var dropped = before.filter(function(c){ return has.indexOf(c.toLowerCase()) < 0; });
        var stale = (cart.discount_codes || []).some(function(c){ return c && !c.applicable; });
        return (stale ? CN._setCodes(now) : Promise.resolve())
          .then(function(){ return CN.fetchCart(); })
          .then(function(fresh){
            CN.syncDiscountCookie(fresh, true);
            if(!quiet || !matched || dropped.length) CN.toast(!matched
              ? '"' + code + '" isn’t valid or doesn’t qualify yet'
              : dropped.length
                ? code.toUpperCase() + ' applied — it can’t be combined with ' + dropped.join(', ') + ', so that was removed'
                : code.toUpperCase() + ' applied — you\'re saving on this order');
            return matched;
          });
      })
      .catch(function(){ CN.toast('Could not apply the code — check your connection'); return false; });
  };

  /* A bag that already holds the prepaid code (applied before 2026-10-14, or kept by Shopify from an
     earlier cart) loses it once, quietly: the bag's total then matches what a COD order pays, and
     Shiprocket still takes the offer off by itself for an online payment. Skipped while a WhatsApp link
     is rebuilding the bag (its own requests are in flight; the next render does it). Once per page, so
     a failed update can't loop. */
  CN._dropPrepaidCode = function(cart){
    var pre = CN._prepaidAutoCode();
    if(!pre || !cart || CN._prepaidDropped || CN._restoring) return;
    var listed = (cart.discount_codes || []).map(function(c){ return c && c.code; })
      .concat(CN.cartCodes(cart).map(function(c){ return c.code; }));
    if(!listed.some(function(c){ return c && String(c).toLowerCase() === pre; })) return;
    CN._prepaidDropped = true;
    var keep = CN.cartCodes(cart).map(function(c){ return c.code; }).filter(function(c){ return c.toLowerCase() !== pre; });
    CN._setCodes(keep).then(function(){ return CN.fetchCart(); }).catch(function(){});
  };

  /* Removes one code and keeps the rest; no code = remove them all. */
  CN.removeDiscountCode = function(code){
    var key = String(code || '').toLowerCase();
    return CN._cartJson()
      .then(function(cart){
        var keep = key ? CN.cartCodes(cart).map(function(c){ return c.code; }).filter(function(c){ return c.toLowerCase() !== key; }) : [];
        return CN._setCodes(keep).then(function(){ return keep; });
      })
      .then(function(keep){ if(!keep.length) CN.clearDiscountCookie(); return CN.fetchCart(); })
      .then(function(fresh){ CN.syncDiscountCookie(fresh, true); CN.toast(code ? String(code).toUpperCase() + ' removed' : 'Coupon removed'); })
      .catch(function(){ CN.toast('Could not remove the coupon — check your connection'); });
  };

  /* pulse a value when it changes (price / total update animation) */
  CN._pulse = function(el, val){
    if(!el) return;
    if(el.textContent !== val){ el.textContent = val; el.classList.remove('val-pulse'); void el.offsetWidth; el.classList.add('val-pulse'); }
  };

  /* ---------- order summary (Estimated Total breakdown, real compare-at savings) ---------- */
  /* Breakdown matches the mock's exact row set — Subtotal / Product discount
     / Coupon / Shipping / Total — and also patches each line card's
     placeholder MRP + %OFF badge from the same real compare-at fetch, so it
     only costs one product.js round trip per distinct line, not two. */
  CN.renderSummary = function(cart){
    /* Subtotal is shown before coupon codes: a product code (FESTIVE100) is
       already netted out of items_subtotal_price, so it's added back here
       and shown once, on the Coupon row — not again as "Product discount". */
    var codes = CN.cartCodes(cart);
    var subtotal = cart.items_subtotal_price + CN._lineCodeDiscount(cart), total = cart.total_price, couponDisc = cart.total_discount || 0;
    var codeDisc = codes.reduce(function(s, c){ return s + c.saved; }, 0);
    var items = cart.items || [];
    /* Paint the real totals now (audit JSC-13): they used to sit at the
       server-rendered ₹0 until every /products/<handle>.js lookup below had
       resolved. Only the MRP/savings rows need that async data. gen drops a
       slower, older run so it can't overwrite a newer cart's summary. */
    var gen = CN._sumGen = (CN._sumGen || 0) + 1;
    var tEl = $('#cartTotal'), stEl = $('#csumSubtotal'), ctEl = $('#csumTotal');
    if(tEl) tEl.textContent = CN.money(total);
    if(stEl) stEl.textContent = CN.money(subtotal);
    if(ctEl) ctEl.textContent = CN.money(total);
    CN._renderOnline(cart, codes, total);
    Promise.all(items.map(function(it){
      return CN.fetchProduct(it.handle).then(function(p){
        var cat = 0;
        if(p && p.variants){ for(var k = 0; k < p.variants.length; k++){ if(p.variants[k].id === it.variant_id){ if(p.variants[k].compare_at_price > it.price) cat = p.variants[k].compare_at_price; break; } } }
        return cat;
      });
    })).then(function(catUnits){
      if(gen !== CN._sumGen) return;   /* superseded by a newer cart */
      var mrpTotal = 0;
      items.forEach(function(it, i){
        var cat = catUnits[i];
        mrpTotal += cat ? cat * it.quantity : it.original_line_price;
        if(!cat) return;
        var ci = document.querySelector('.ccart-item[data-key="' + it.key + '"]');
        if(!ci) return;
        var mrpEl = ci.querySelector('[data-role="mrp"]'), badgeEl = ci.querySelector('[data-role="badge"]');
        if(mrpEl){ mrpEl.textContent = CN.money(cat); mrpEl.hidden = false; }
        if(badgeEl){
          var pct = Math.round((1 - it.price / cat) * 100);
          if(pct > 0){ badgeEl.textContent = pct + '% OFF'; badgeEl.hidden = false; }
        }
      });
      if(mrpTotal < subtotal) mrpTotal = subtotal;
      var productDisc = Math.max(0, mrpTotal - subtotal);
      var totalSavings = productDisc + couponDisc;

      var setT = function(sel, v){ var e = $(sel); if(e) e.textContent = v; };
      setT('#csumSubtotal', CN.money(subtotal));

      var mrpRow = $('#csumMrpDiscRow');
      if(productDisc > 0){ if(mrpRow) mrpRow.hidden = false; setT('#csumMrpDisc', '-' + CN.money(productDisc)); }
      else if(mrpRow) mrpRow.hidden = true;

      var couponRow = $('#csumCouponRow');
      if(codeDisc > 0 && codes.length){
        if(couponRow) couponRow.hidden = false;
        setT('#csumCouponLabel', 'Coupon (' + codes.map(function(c){ return c.code; }).join(' + ') + ')');
        setT('#csumCouponAmt', '-' + CN.money(codeDisc));
      } else if(couponRow) couponRow.hidden = true;

      /* Shipping is free on every order with no minimum — real, not a
         placeholder default. */
      /* Free only once the subtotal reaches the free-shipping threshold; below it the
         amount is worked out at checkout, so don't claim FREE (and keep the same rule the
         progress bar uses). No threshold configured = the old behaviour, FREE. */
      var shipThr = Number((window.CNSettings || {}).freeShipThreshold) || 0;
      var shipFree = !shipThr || cart.items_subtotal_price >= shipThr;   /* same figure as the progress bar */
      setT('#csumShipping', shipFree ? 'FREE' : 'Calculated at checkout');
      var shipRow = $('#csumShipping') && $('#csumShipping').parentNode;
      if(shipRow) shipRow.classList.toggle('is-pos', shipFree);
      setT('#csumTotal', CN.money(total));
      CN._pulse($('#cartTotal'), CN.money(total));

      var mrpEl2 = $('#cartMrp');
      if(mrpEl2){
        if(totalSavings > 0 && mrpTotal > total){ mrpEl2.textContent = CN.money(mrpTotal); mrpEl2.hidden = false; }
        else mrpEl2.hidden = true;
      }
      var bar = $('#cartSavingsBar');
      if(bar){
        if(totalSavings > 0){ bar.hidden = false; bar.textContent = "You're saving " + CN.money(totalSavings); }
        else bar.hidden = true;
      }
    }).catch(function(){});
  };

  /* "₹1,349 if you pay online" under the bag's Estimated Total (checkout drop-off audit fix #1, 22 Oct 2026).
     The total stays the amount before a payment method is picked — a COD shopper must never see less than
     they're charged (see cart-drawer.liquid). This line adds what Shiprocket takes off by itself for an online
     payment: the automatic product offer (CNSettings.autoOffer — FESTIVE100 ₹100, once per order, when the bag
     holds one of its products) unless the shopper already applied that code here, then the prepaid saving from
     its minimum. Shown only when the bag holds a product the automatic offer covers. */
  CN._renderOnline = function(cart, codes, total){
    var el = $('#cartOnline'); if(!el) return;
    var s = window.CNSettings || {}, ao = s.autoOffer;
    var has = !!(ao && ao.amount > 0 && ao.products && (cart.items || []).some(function(it){ return ao.products.indexOf(it.product_id) > -1; }));
    if(!has){ el.hidden = true; return; }
    var auto = CN._shiprocketAutoCodes();
    var applied = (codes || []).some(function(c){ return c.saved > 0 && auto.indexOf(String(c.code).toLowerCase()) > -1; });
    var online = total - (applied ? 0 : ao.amount);
    if(s.prepaidOff > 0 && online >= (s.prepaidMin || 0)) online -= s.prepaidOff;
    if(online >= total || online <= 0){ el.hidden = true; return; }
    el.innerHTML = '<b>' + CN.money(online) + '</b> if you pay online';
    el.hidden = false;
  };

  CN.fetchCart = function(){
    return fetch(window.Shopify.routes.root + 'cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){ CN.renderCart(cart); return cart; })
      /* Every sibling cart call (addToCart, changeQty) toasts on failure —
         this one didn't, so a network hiccup on cart-open left the drawer
         showing stale/empty content with no feedback and an unhandled
         promise rejection in the console. */
      .catch(function(){ CN.toast('Could not load your bag — check your connection'); });
  };

  /* ---------- product data cache (wishlist + cart savings summary) ---------- */
  /* In-memory first (fastest, always fresh within one page); sessionStorage
     second, so the SAME products don't get re-fetched from scratch on every
     new page load in one visit — a cart with 5 lines was firing 5 product.js
     requests on every single navigation, whether or not the drawer was ever
     opened. Product price/compare-at data changes rarely enough that a
     same-tab-session cache is safe; it's gone the moment the tab closes. */
  CN._pcache = {};
  CN._pcacheKey = function(handle){ return 'cn-pcache:' + handle; };
  CN.fetchProduct = function(handle){
    if(CN._pcache[handle]) return Promise.resolve(CN._pcache[handle]);
    try{
      var stored = sessionStorage.getItem(CN._pcacheKey(handle));
      if(stored){ var p = JSON.parse(stored); CN._pcache[handle] = p; return Promise.resolve(p); }
    }catch(e){}
    return fetch(window.Shopify.routes.root + 'products/' + handle + '.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if(p){
          CN._pcache[handle] = p;
          try{ sessionStorage.setItem(CN._pcacheKey(handle), JSON.stringify(p)); }catch(e){}
        }
        return p;
      })
      .catch(function(){ return null; });
  };
  /* CN.renderDrawerWish (the old drawer's "saved for later" list) was
     removed along with the rest of the previous drawer — see the note at
     the top of the click-delegation block above. */

  /* ---------- fly to cart ----------
     One engine for every Add-to-Cart surface. Given the clicked trigger we
     locate the product image, clone it, and arc the clone into the cart icon
     (GPU-only: transform + opacity via the Web Animations API). The drawer is
     opened by addToCart only after the flight lands, so nothing flickers. */
  CN.reduceMotion = function(){ return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); };

  /* Resolve the image to fly from any add trigger (card, rail, rec, saved,
     quick-view, PDP gallery, sticky bar). Falls back to the PDP/QV image. */
  CN.cartImgFor = function(el){
    if(!el || !el.closest) return null;
    var pairs = [
      ['.card', '.frame img, .card-media img'],
      ['.ccart-rec', '.ccart-rec-img img'],
      ['.lk-card', '.lk-card-img img'],
      ['.sticky-atc', '.si .th img'],
      ['.qv', '#qvImg'],
      ['.pdp', '#galImg, .gal-main img']
    ];
    for(var i=0;i<pairs.length;i++){
      var c = el.closest(pairs[i][0]);
      if(c){
        /* first one actually on screen — the PDP holds a hidden stage image
           on phones and a hidden strip on desktop */
        var ims = c.querySelectorAll(pairs[i][1]);
        for(var j=0;j<ims.length;j++){
          var r = ims[j].getBoundingClientRect();
          var mid = r.left + r.width / 2;
          if(r.width && mid > 0 && mid < window.innerWidth) return ims[j];
        }
      }
    }
    return document.getElementById('qvImg') || document.getElementById('galImg') || null;
  };

  /* subtle bounce on the cart icon(s) */
  CN.bumpCart = function(){
    $$('.js-cart-open').forEach(function(c){
      c.classList.remove('cart-bump'); void c.offsetWidth; c.classList.add('cart-bump');
      setTimeout(function(){ c.classList.remove('cart-bump'); }, 640);
    });
  };

  /* Cart nudge (owner 2026-10-06): while the bag has something in it, the
     header bag gives a small wiggle and its count pulses — 2.5s after the
     page loads, then every 10s, at most 4 times per page. A reminder, not a
     distraction: skipped while the drawer is open, the tab is hidden or the
     add-to-cart bounce is playing, and off for reduced motion. */
  (function(){
    if(CN.reduceMotion()) return;
    var shown = 0, MAX = 4;
    function itemCount(){
      var el = document.querySelector('.js-cart-count');
      return el && el.style.display !== 'none' ? (parseInt(el.textContent, 10) || 0) : 0;
    }
    function nudge(){
      var d = document.getElementById('cartDrawer');
      if(!document.hidden && !(d && d.classList.contains('open')) && itemCount() > 0){
        var did = false;
        $$('.js-cart-open').forEach(function(c){
          if(!c.querySelector('.js-cart-count') || c.classList.contains('cart-bump')) return;
          c.classList.remove('cart-nudge'); void c.offsetWidth; c.classList.add('cart-nudge');
          setTimeout(function(){ c.classList.remove('cart-nudge'); }, 950);
          did = true;
        });
        if(did) shown++;
      }
      if(shown < MAX) setTimeout(nudge, 10000);
    }
    setTimeout(nudge, 2500);
  })();

  /* Clone `img` and fly it to the cart. Returns a Promise that resolves when
     the flight ends (or right away for reduced-motion / no image). Each call
     is independent, so rapid adds fly in parallel and self-clean. */
  CN.flyToCart = function(img){
    return new Promise(function(resolve){
      var cart = $('.js-cart-open');
      if(!img || !cart || CN.reduceMotion() || typeof img.animate !== 'function'){ CN.bumpCart(); resolve(); return; }
      var s = img.getBoundingClientRect(), t = cart.getBoundingClientRect();
      if(!s.width || !s.height || !t.width){ CN.bumpCart(); resolve(); return; }
      var clone = document.createElement('img');
      clone.src = img.currentSrc || img.src;
      clone.alt = ''; clone.setAttribute('aria-hidden', 'true');
      clone.className = 'fly-clone';
      clone.style.width = s.width + 'px';
      clone.style.height = s.height + 'px';
      clone.style.transform = 'translate3d(' + s.left + 'px,' + s.top + 'px,0)';   /* no first-frame flash */
      document.body.appendChild(clone);
      var ex = t.left + t.width / 2 - s.width / 2;
      var ey = t.top + t.height / 2 - s.height / 2;
      var mx = s.left + (ex - s.left) * 0.5;
      var my = Math.min(s.top, ey) - 70;                                            /* upward arc */
      var anim = clone.animate([
        { transform: 'translate3d(' + s.left + 'px,' + s.top + 'px,0) scale(1)',  opacity: 1,   easing: 'cubic-bezier(.22,1,.36,1)' },
        { transform: 'translate3d(' + mx + 'px,' + my + 'px,0) scale(.62)',        opacity: .9,  offset: .5, easing: 'cubic-bezier(.55,.06,.68,.19)' },
        { transform: 'translate3d(' + ex + 'px,' + ey + 'px,0) scale(.14)',        opacity: .25 }
      ], { duration: 640, fill: 'forwards' });
      var done = false;
      var finish = function(){ if(done) return; done = true; if(clone.parentNode) clone.remove(); CN.bumpCart(); resolve(); };
      anim.onfinish = finish; anim.oncancel = finish;
      setTimeout(finish, 950);                                                      /* safety net */
    });
  };

  /* A refused add (422, e.g. "only 6 left") can still have added the units that
     exist. Refetch so the badge and drawer show the real bag, and open the drawer
     when the bag did grow; callers still get null (the add didn't go as asked). */
  CN._afterRefusedAdd = function(res, before, flight){
    CN.toast(res.data.description || res.data.message || 'Could not add to bag');
    return CN.fetchCart().then(function(c){
      if(c && before != null && c.item_count > before) Promise.resolve(flight).then(function(){ CN.openCart(); });
      return null;
    }, function(){ return null; });
  };

  CN.addToCart = function(id, qty, sourceImg){
    var flight = CN.flyToCart(sourceImg);                       /* start immediately; runs during the fetch */
    var body = $('#cartBody'); if(body) body.classList.add('is-loading');
    var before = CN._lastCart ? CN._lastCart.item_count : null;
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id:id, quantity: qty||1}]})
    }).then(function(r){ return r.json().then(function(d){ return {ok:r.ok, data:d}; }); })
      .then(function(res){
        if(body) body.classList.remove('is-loading');
        if(!res.ok) return CN._afterRefusedAdd(res, before, flight);
        CN.toast('Added to bag');
        return CN.fetchCart().then(function(c){
          Promise.resolve(flight).then(function(){ CN.openCart(); });   /* open the drawer only after the flight lands */
          return c;
        });
      }).catch(function(){
        if(body) body.classList.remove('is-loading');
        CN.toast('Network error — please try again');
      });
  };

  /* ---------- sweep hover (.btn-sweep, styles in theme.css) ----------
     Web Animations API, so it runs on the compositor with no library. Enter:
     the fill jumps below the button and rises to cover it. Leave: it carries
     on upward from wherever it is and exits through the top. Touch: the same
     in/out as a press flash. Delegated, so buttons rendered later (quick
     view, section reloads) work too. CN.sweepSync(btn) clears a fill left on
     a button that was disabled while the pointer left it (no pointerout). */
  (function(){
    CN.sweepSync = function(){};
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var EASE = 'cubic-bezier(.3,1,.3,1)';
    function sweep(btn, into){
      var f = btn.querySelector('.btn-fill');
      if(!f || !f.animate || btn.classList.contains('is-hover') === into) return;
      var from = into ? 'translateY(76%)' : getComputedStyle(f).transform;
      if(!from || from === 'none') from = 'translateY(0)';
      if(f.__a) f.__a.cancel();
      f.__a = f.animate([{ transform: from }, { transform: into ? 'translateY(0)' : 'translateY(-76%)' }],
        { duration: into ? 600 : 520, easing: EASE, fill: 'forwards' });
      btn.classList.toggle('is-hover', into);
    }
    function btnOf(e){ return e.target && e.target.closest ? e.target.closest('.btn-sweep') : null; }
    CN.sweepSync = function(btn){ if(btn && !btn.matches(':hover')) sweep(btn, false); };
    document.addEventListener('pointerover', function(e){
      if(e.pointerType !== 'mouse') return;
      var b = btnOf(e); if(b && !b.disabled && !b.contains(e.relatedTarget)) sweep(b, true);
    });
    document.addEventListener('pointerout', function(e){
      if(e.pointerType !== 'mouse') return;
      var b = btnOf(e); if(b && !b.contains(e.relatedTarget)) sweep(b, false);
    });
    document.addEventListener('pointerdown', function(e){
      if(e.pointerType === 'mouse') return;
      var b = btnOf(e); if(b && !b.disabled) sweep(b, true);
    }, { passive: true });
    ['pointerup', 'pointercancel'].forEach(function(t){
      document.addEventListener(t, function(e){
        if(e.pointerType === 'mouse') return;
        var b = btnOf(e); if(b) setTimeout(function(){ sweep(b, false); }, 260);
      }, { passive: true });
    });
    document.addEventListener('focusin', function(e){
      var b = e.target; if(b.classList && b.classList.contains('btn-sweep') && b.matches(':focus-visible')) sweep(b, true);
    });
    document.addEventListener('focusout', function(e){
      var b = e.target; if(b.classList && b.classList.contains('btn-sweep')) sweep(b, false);
    });
  })();

  /* "Add All to Cart" (Complete the Setup, sections/shop-the-look.liquid) — one
     real Ajax call with every eligible id, not a loop of single adds (avoids N
     round trips and N drawer flickers). Same /cart/add.js endpoint CN.addToCart
     uses; Shopify's own items array already supports more than one line. */
  CN.addAllToCart = function(ids, sourceImg){
    var flight = CN.flyToCart(sourceImg);
    var body = $('#cartBody'); if(body) body.classList.add('is-loading');
    var before = CN._lastCart ? CN._lastCart.item_count : null;
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items: ids.map(function(id){ return {id:id, quantity:1}; })})
    }).then(function(r){ return r.json().then(function(d){ return {ok:r.ok, data:d}; }); })
      .then(function(res){
        if(body) body.classList.remove('is-loading');
        if(!res.ok) return CN._afterRefusedAdd(res, before, flight);
        CN.toast('Added ' + ids.length + ' items to bag');
        return CN.fetchCart().then(function(c){
          Promise.resolve(flight).then(function(){ CN.openCart(); });
          return c;
        });
      }).catch(function(){
        if(body) body.classList.remove('is-loading');
        CN.toast('Network error — please try again');
      });
  };

  /* ---------- WhatsApp cart-recovery link: /?cn_cart=<items>[_<CODE>] ----------
     Opened from the abandoned-cart WhatsApp messages (tracking-proxy
     src/cart-recovery.js). <items> is "variantIdxQty" pairs joined by dots, e.g.
     4455x1.4456x2; an optional "_<CODE>" suffix applies that coupon (only
     messages 2 and 3 promise one; PAYONLINE itself is skipped, since Shiprocket
     applies it on an online payment — CN.applyDiscountCode). Rebuilds the bag with the SAME Ajax call the
     Add to Bag button uses, then opens SHIPROCKET's checkout straight away
     (CN.goShiprocketCart — owner rule: never Shopify's native checkout). Shiprocket
     keeps its own session, so a shopper it already knows continues from there
     instead of retyping; there is no public "resume this exact step" URL. If
     Shiprocket can't open, or an item has sold out, the bag drawer stays open
     instead so the shopper is never stranded. Set CN.WA_DIRECT_CHECKOUT = false to
     stop at the drawer.
     Safe to re-run: the param is removed from the URL straight away (refresh /
     back / sharing the link won't add anything), and lines already in the bag are
     topped up to the wanted quantity, not doubled. */
  CN.restoreCartFromLink = function(){
    if(!window.URLSearchParams || CN._restoring) return;
    var raw = new URLSearchParams(window.location.search).get('cn_cart');
    if(!raw) return;
    CN._restoring = true;
    try{
      var u = new URL(window.location.href); u.searchParams.delete('cn_cart');
      window.history.replaceState(null, '', u.pathname + u.search + u.hash);
    }catch(e){}

    var parts = String(raw).slice(0, 300).split('_');
    var code = /^[A-Za-z0-9-]{3,30}$/.test(parts[1] || '') ? parts[1] : '';
    var want = [];
    parts[0].split('.').slice(0, 8).forEach(function(seg){
      var m = /^(\d{1,16})x(\d{1,2})$/.exec(seg);
      if(m && Number(m[2]) > 0) want.push({ id: Number(m[1]), quantity: Math.min(Number(m[2]), 10) });
    });
    if(!want.length){ CN._restoring = false; return; }

    CN.clarity('event', 'wa_cart_link');
    var root = window.Shopify.routes.root;
    /* Open the drawer now, in its loading state: the restore below is four
       requests in a row, and a shopper arriving from WhatsApp on 4G should see
       the bag respond to the tap, not a bare homepage for a few seconds. */
    var cartBody = $('#cartBody'); if(cartBody) cartBody.classList.add('is-loading');
    /* Calm mode: until Shiprocket opens, the drawer shows ONE "getting your bag ready" state. Without it the
       drawer flashed its normal states in turn (empty-bag message, coupon box, recommendations, confetti twice,
       a toast over the checkout button) — a phone recording of this flow looked glitchy. See .ccart.is-restoring
       in theme.css, and the CN._silentRestore checks in renderCart / celebrate / applyDiscountCode. */
    var calm = $('#cartDrawer');
    CN._silentRestore = true; if(calm) calm.classList.add('is-restoring');
    var emptyH = $('#cartBody .ccart-empty h3'); if(emptyH) emptyH.textContent = 'Getting your bag ready…';   /* already painted */
    var endCalm = function(){ CN._silentRestore = false; if(calm) calm.classList.remove('is-restoring'); };
    CN.openCart();
    var complete = false;      /* every wanted line made it into the bag */
    CN._cartJson().then(function(cart){
      var have = {};
      (cart.items || []).forEach(function(it){ have[it.variant_id] = (have[it.variant_id] || 0) + it.quantity; });
      var add = [];
      want.forEach(function(w){
        var short = w.quantity - (have[w.id] || 0);
        if(short > 0) add.push({ id: w.id, quantity: short });
      });
      if(!add.length) return { ok: true };
      return fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: add })
      }).then(function(r){ return { ok: r.ok }; });
    }).then(function(res){
      if(!res.ok) CN.toast('One of those items is no longer available');
      else complete = true;
      return CN.fetchCart();
    }).then(function(){
      /* Syncs the Shiprocket cookie; quiet = no success toast (a failure still toasts). */
      return code ? CN.applyDiscountCode(code, { quiet: true }) : null;
    }).catch(function(){
      complete = false;
      CN.toast('Could not restore your bag — please try again');
    }).then(function(){
      if(cartBody) cartBody.classList.remove('is-loading');
      CN._restoring = false;
      /* After the coupon cookie is set, so Shiprocket's iframe opens with it applied. */
      if(complete && CN.WA_DIRECT_CHECKOUT !== false){
        CN.clarity('event', 'wa_cart_link_checkout');
        CN.goShiprocketCart(null);
        setTimeout(endCalm, 8000);     /* if Shiprocket never opens, show the bag instead of the placeholder */
      } else endCalm();
    });
  };

  CN._qtyFlight = [];
  /* One cart/change at a time. Two lines changed together fired two
     concurrent requests and Shopify kept only one of them (verified on /cart:
     +1 on two lines left the second unchanged). Queued, each request starts
     from the cart the previous one saved. */
  CN._qtyChain = Promise.resolve();
  CN.changeQty = function(key, qty){
    var body = $('#cartBody'); if(body) body.classList.add('is-loading');
    var send = function(){ return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id:key, quantity:qty})
    }); };
    var sent = CN._qtyChain.then(send, send);
    CN._qtyChain = sent.then(function(){}, function(){});
    var req = sent.then(function(r){
        var ok = r.ok;
        return r.json().then(function(data){ return {ok:ok, data:data}; });
      })
      .then(function(res){
        if(body) body.classList.remove('is-loading');
        if(!res.ok){
          /* cart/change.js can 4xx (a line no longer valid, qty rejected, etc.) and still
             return a JSON body — that body is an error payload, not a cart, and has no
             item_count, so feeding it to renderCart used to paint the drawer as an empty
             bag over a cart that wasn't actually empty. Re-fetch the real cart instead. */
          CN.toast((res.data && res.data.description) || 'Could not update your bag');
          CN.fetchCart();
          document.dispatchEvent(new CustomEvent('cn:cart:failed'));   /* /cart re-syncs on this (JSC-12) */
          return null;
        }
        CN.renderCart(res.data);
        document.dispatchEvent(new CustomEvent('cn:cart:changed', {detail: res.data}));
        return res.data;
      })
      .catch(function(){ if(body) body.classList.remove('is-loading'); CN.toast('Could not update bag'); document.dispatchEvent(new CustomEvent('cn:cart:failed')); });
    CN._qtyFlight.push(req);
    req.then(function(){ var i = CN._qtyFlight.indexOf(req); if(i > -1) CN._qtyFlight.splice(i, 1); });
    return req;
  };

  /* Checkout must never run on a cart that's missing the shopper's last
     qty/remove tap (audit JSC-02): those are debounced 200-340 ms and the
     checkout buttons (drawer Buy Now, /cart, Shiprocket's injected button)
     used to navigate straight away, checking out the stale server cart.
     Capture-phase on window so this runs before Shiprocket's own handler;
     if anything is pending or in flight, hold the click, send + await it,
     then replay the click. */
  CN.flushQty = function(){
    var jobs = [];
    Object.keys(CN._qtyPending || {}).forEach(function(k){
      clearTimeout(CN._qtyTimers[k]);
      var q = CN._qtyPending[k]; delete CN._qtyPending[k];
      jobs.push(CN.changeQty(k, q));
    });
    return Promise.all(jobs.concat(CN._qtyFlight.slice()));
  };
  window.addEventListener('click', function(e){
    var el = e.target;
    if(!el || !el.closest) return;
    var btn = el.closest('.ccart-checkout, button[name="checkout"], .shiprocket-headless');
    if(!btn) return;
    if(!Object.keys(CN._qtyPending || {}).length && !CN._qtyFlight.length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var target = e.target;
    CN.flushQty().then(function(){
      var again = document.contains(target) ? target
        : (btn.classList.contains('ccart-checkout') ? $('.ccart-checkout') : null);
      if(again) again.click();
    });
  }, true);

  /* ---------- Shiprocket-only checkout (2026-10, owner rule) ----------
     Every checkout must go through Shiprocket (Fastrr) — never Shopify's own
     checkout, even if that means asking the shopper to try again. Three
     routes used to lead to Shopify checkout:
       1. Shopify's own checkout button (cart drawer .ccart-checkout, /cart
          page button[name="checkout"]) is live until Shiprocket's deferred
          script swaps it for its button — a tap in that window (slow phone,
          Facebook/Instagram in-app browser) submitted to Shopify checkout.
          Those taps are now held and handed to Shiprocket once it is ready.
       2. The product page's Buy Now fell back to Shopify checkout when the
          script wasn't ready (fixed in main-product.liquid: it now waits).
       3. Shiprocket's own script redirects to a Shopify /checkout/ or
          /cart/<variant>:<qty> link when its checkout reports "down" or
          fails to start. Where the browser has the Navigation API (Chrome,
          Android WebViews incl. Facebook/Instagram, newer iOS) that
          navigation is cancelled and the shopper is asked to try again.
     This listener is registered after the qty-flush one above, so a pending
     quantity change still saves first and its replayed click lands here. */
  CN.srReady = function(){
    var ev = window.shiprocketCheckoutEvents;
    return !!(ev && typeof ev.buyCart === 'function' && typeof ev.buyProduct === 'function');
  };
  /* If the script failed to load (sr-checkout.liquid flags cnSrLoadFailed),
     ask for it once more; the theme calls buyCart/buyProduct directly, so it
     works even though that late copy misses DOMContentLoaded. */
  CN.srRetryLoad = function(){
    if(CN.srReady() || CN._srRetried || !window.cnSrLoadFailed) return;
    CN._srRetried = true;
    var s = document.createElement('script');
    s.src = 'https://fastrr-boost-ui.pickrr.com/assets/js/channels/shopify.js?r=' + Date.now();
    s.async = true;
    document.head.appendChild(s);
  };
  CN.whenSr = function(ms, cb){
    var t0 = Date.now();
    CN.srRetryLoad();
    (function poll(){
      if(CN.srReady()){ cb(true); return; }
      if(Date.now() - t0 > ms){ cb(false); return; }
      if(Date.now() - t0 > 4000) CN.srRetryLoad();
      setTimeout(poll, 150);
    })();
  };
  CN.srBlockedMsg = 'Checkout couldn’t open just now. Please try again in a moment.';
  /* Cart checkout through Shiprocket: its own rendered button if it exists
     (it carries Shiprocket's config), else its buyCart() directly. */
  CN.srOpenCart = function(from){
    var srBtn = document.querySelector('.shiprocket-headless .sr-headless-checkout');
    if(srBtn && srBtn !== from){ srBtn.click(); return true; }
    try{
      window.shiprocketCheckoutEvents.buyCart({ currentTarget: from, target: from, stopPropagation: function(){}, preventDefault: function(){} });
      return true;
    }catch(err){ return false; }
  };
  CN.goShiprocketCart = function(from){
    if(CN._srCartWaiting) return;
    CN._srCartWaiting = true;
    var label = from && from.querySelector ? (from.querySelector('.ccart-checkout-label') || from) : null;
    var orig = label ? label.textContent : '';
    if(label && !CN.srReady()) label.textContent = 'Opening secure checkout…';
    if(from && from.setAttribute) from.setAttribute('aria-busy', 'true');
    CN.whenSr(15000, function(ok){
      CN._srCartWaiting = false;
      if(label) label.textContent = orig;
      if(from && from.removeAttribute) from.removeAttribute('aria-busy');
      if(ok && CN.srOpenCart(from)) return;
      CN.clarity('event', 'shiprocket_unavailable');
      CN.checkoutFailed();
    });
  };
  var NATIVE_CHECKOUT = 'button[name="checkout"], .ccart-checkout, a[href="/checkout"], a[href^="/checkout?"], a[href^="/checkout/"]';
  window.addEventListener('click', function(e){
    var el = e.target;
    if(!el || !el.closest || el.closest('.sr-headless-checkout')) return;
    var nat = el.closest(NATIVE_CHECKOUT);
    if(!nat) return;
    e.preventDefault(); e.stopImmediatePropagation();
    CN.goShiprocketCart(nat);
  }, true);
  /* Enter key or any other submit of the cart form towards checkout. */
  document.addEventListener('submit', function(e){
    var sub = e.submitter, f = e.target;
    var toCheckout = (sub && sub.name === 'checkout') ||
      (f && f.getAttribute && /(^|\/)checkout(\/|\?|$)/.test(f.getAttribute('action') || ''));
    if(!toCheckout) return;
    e.preventDefault(); e.stopImmediatePropagation();
    CN.goShiprocketCart(sub || f);
  }, true);
  /* Route 3: cancel any same-site navigation to Shopify checkout. Only the two
     address shapes Shiprocket's fallback builds are matched — /checkout and a
     /cart/<variant>:<qty> permalink — so its own order-success redirect and
     Shopify order-status pages (/…/orders/…, /checkouts/…) are untouched. */
  if(window.navigation && typeof window.navigation.addEventListener === 'function'){
    window.navigation.addEventListener('navigate', function(e){
      try{
        var u = new URL(e.destination.url);
        /* Same site, or the store's other domains: Shiprocket's fallback can build
           its URL on the *.myshopify.com host or the bare/www shop domain. */
        var h = u.hostname;
        if(u.origin !== window.location.origin && !/(^|\.)culturenest\.in$/.test(h) && !/\.myshopify\.com$/.test(h)) return;
        if(!/^\/checkout\/?$/.test(u.pathname) && !/^\/cart\/\d+:\d+(,\d+:\d+)*\/?$/.test(u.pathname)) return;
        if(!e.cancelable) return;
        e.preventDefault();
        CN.clarity('event', 'native_checkout_blocked');
        document.dispatchEvent(new CustomEvent('cn:checkout-blocked'));
        CN.checkoutFailed();
      }catch(err){}
    });
  }

  /* ---------- Shiprocket checkout steps → Clarity (checkout-repair brief Phase 2 #8c, 2026-10-16) ----------
     Shiprocket's checkout runs in its own frame, so Clarity cannot see inside it. The frame talks
     to this page with postMessage (read from Shiprocket's channels/shopify.js):
       {trigger:'gtag'|'gtm-events', data:{event}}         GA-style steps (begin_checkout, add_payment_info, purchase …)
       {trigger:'shopify-custom-events', data:{eventName}} the events it forwards to Shopify analytics
       {trigger:'mount-otpLess'}  OTP screen · {trigger:'headless-close'}  checkout closed
       {actions:[{action:'ucEventHandler', data:{eventName}} | 'createPayment' | 'headlessClose' | 'redirectTo']}
     Each step becomes a Clarity event "sr_<name>" (once per page view) and the session is tagged
     sr_last_step, so Clarity can filter sessions by how far checkout got. The common GA steps also
     get the names from the brief (sr_checkout_open, sr_phone_submitted, sr_address_done,
     sr_payment_selected, sr_order_placed). Only the NAME is ever used — never the message data,
     which can carry the shopper's phone — and only messages from Shiprocket's own hosts count. */
  CN._srSeen = {};
  CN._srAlias = { begin_checkout: 'checkout_open', login: 'phone_submitted', sign_up: 'phone_submitted', add_shipping_info: 'address_done', add_payment_info: 'payment_selected', purchase: 'order_placed' };
  CN._srStep = function(name){
    name = String(name || '').toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '').slice(0, 40);
    if(!name || CN._srSeen[name]) return;
    CN._srSeen[name] = 1;
    CN.clarity('event', 'sr_' + name);
    CN.clarity('set', 'sr_last_step', name);
    if(CN._srAlias[name]) CN._srStep(CN._srAlias[name]);
  };
  CN._srMessage = function(e){
    try{
      var host = new URL(e.origin).hostname;
      if(!/(^|\.)(pickrr\.com|shiprocket\.in|shiprocket\.co|fastrr\.com)$/.test(host)) return;
      var d = e.data;
      if(!d || typeof d !== 'object') return;
      var t = d.trigger;
      if(t === 'gtag' || t === 'gtm-events') CN._srStep(d.data && d.data.event);
      else if(t === 'shopify-custom-events') CN._srStep(d.data && d.data.eventName);
      else if(t === 'mount-otpLess') CN._srStep('otp_shown');
      else if(t === 'headless-close') CN._srStep('checkout_closed');
      if(Object.prototype.toString.call(d.actions) === '[object Array]'){
        d.actions.forEach(function(a){
          if(!a) return;
          if(a.action === 'ucEventHandler') CN._srStep(a.data && a.data.eventName);
          else if(a.action === 'createPayment') CN._srStep('payment_started');
          else if(a.action === 'headlessClose') CN._srStep('checkout_closed');
          else if(a.action === 'redirectTo') CN._srStep('redirect');
        });
      }
    }catch(err){}
  };
  window.addEventListener('message', CN._srMessage);

  /* open/close cart — delegated and registered as soon as this deferred script
     runs. Binding inside DOMContentLoaded waited for Shiprocket's slower deferred
     scripts, so for the first seconds a tap on the cart icon followed its
     href to an empty /cart page instead of opening the drawer. */
  document.addEventListener('click', function(e){
    var t = e.target; if(!t || !t.closest) return;
    if(t.closest('.js-cart-open')){ e.preventDefault(); CN.openCart(); CN.fetchCart(); return; }
    if(t.closest('#cartClose') || t.closest('#cartScrim')) CN.closeCart();
  });

  document.addEventListener('DOMContentLoaded', function(){
    drawer = $('#cartDrawer'); scrim = $('#cartScrim');

    /* ticker — one line, the real prepaid offer, rendered by cart-drawer.liquid only when
       that offer is configured ("Prepaid orders are delivered faster" was removed 2026-10-16:
       nothing backs it). Tap scrolls to recs so it leads somewhere. */
    (function(){
      var el = $('#cartTicker'); if(!el) return;
      el.addEventListener('click', function(){ var r = $('#drawerRecs'); if(r) r.scrollIntoView({behavior:'smooth', block:'nearest'}); });
    })();

    /* Gift note (toggle/textarea/debounced save to cart.note) was removed
       on request — see the matching note in theme.css. */

    /* Estimated Total breakdown expand / collapse */
    var sumToggle = $('#cartTotalToggle');
    if(sumToggle){
      sumToggle.addEventListener('click', function(){
        var open = sumToggle.getAttribute('aria-expanded') !== 'true';
        sumToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        var sum = $('#cartSummary'); if(sum) sum.classList.toggle('is-open', open);
      });
    }

    /* cart offer panel expand / collapse (terms + the one-tap "Apply CODE") */
    var coToggle = $('#coToggle');
    if(coToggle){
      coToggle.addEventListener('click', function(){
        var open = coToggle.getAttribute('aria-expanded') !== 'true';
        coToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        var panel = $('#coPanel'); if(panel) panel.hidden = !open;
      });
    }
    var couponInputEl = $('#cartCouponInput'), couponApplyBtn = $('#cartCouponApply');
    /* clear the input once the code has actually landed — leaving the text
       sitting there after a successful apply reads as "did that even go
       through?" when the only other confirmation is the applied state that
       replaces this whole form. Left in place on a miss, so there's still
       something to correct rather than retype from scratch. */
    var submitCoupon = function(){
      var code = couponInputEl && couponInputEl.value;
      var errEl = $('#cartCouponError');
      if(!code || !code.trim()){
        if(errEl){ errEl.textContent = 'Enter a code'; errEl.hidden = false; }
        if(couponInputEl) couponInputEl.focus();
        return;
      }
      CN.applyDiscountCode(code).then(function(matched){
        if(matched){
          if(couponInputEl) couponInputEl.value = '';
          if(errEl){ errEl.hidden = true; errEl.textContent = ''; }
        } else if(errEl){
          errEl.textContent = '"' + code + '" isn’t valid or doesn’t qualify yet';
          errEl.hidden = false;
        }
      });
    };
    if(couponApplyBtn) couponApplyBtn.addEventListener('click', submitCoupon);
    if(couponInputEl) couponInputEl.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); submitCoupon(); } });
    /* Remove button — delegated, since CN.renderCartCoupon rebuilds this
       block's innerHTML on every cart fetch and a direct listener would be lost */
    var couponAppliedEl = $('#cartCouponApplied');
    if(couponAppliedEl){
      couponAppliedEl.addEventListener('click', function(e){
        var btn = e.target.closest('.ccart-coupon-remove');
        if(btn) CN.removeDiscountCode(btn.dataset.code);
      });
    }
    var coFillBtn = $('#coFillBtn');
    if(coFillBtn){
      coFillBtn.addEventListener('click', function(){
        if(coFillBtn.disabled) return;
        var code = coFillBtn.dataset.code;
        if(couponInputEl) couponInputEl.value = code;
        CN.applyDiscountCode(code).then(function(matched){
          if(matched && couponInputEl) couponInputEl.value = '';
        });
      });
    }

    /* qty + remove (delegated) — optimistic + debounced, so rapid taps coalesce.
       Shared with the standalone /cart page (sections/main-cart.liquid),
       which lays lines out as <tr> with no drawer wrapper — '.ccart-item, tr'
       covers both containers, each holding a differently-classed qty span
       (.ccart-qty span here, .qty span there). */
    CN._qtyTimers = CN._qtyTimers || {};
    CN._qtyPending = CN._qtyPending || {};
    function schedQty(k, qty, ms){
      clearTimeout(CN._qtyTimers[k]);
      CN._qtyPending[k] = qty;
      CN._qtyTimers[k] = setTimeout(function(){ delete CN._qtyPending[k]; CN.changeQty(k, qty); }, ms);
    }
    document.addEventListener('click', function(e){
      var q = e.target.closest('.js-qty');
      if(q){
        e.preventDefault();
        var key = q.dataset.key;
        /* Both remove paths below used to fire clearTimeout+setTimeout without
           saving the new timer id back into CN._qtyTimers[key] — only the
           increment/decrement path (below) did. A fast double-tap on the same
           line (remove, then a stray tap while it's animating out; or minus
           at qty 1 followed by a plus) could only ever cancel a timer of the
           SAME kind, letting a remove-to-0 and a set-to-next both end up in
           flight for one cart line. */
        if(q.classList.contains('rm')){                 /* animated remove */
          var ciR = q.closest('.ccart-item, tr'); if(ciR) ciR.classList.add('ci-out');
          schedQty(key, 0, 200);
          return;
        }
        var delta = parseInt(q.dataset.delta, 10) || 0;
        var ci = q.closest('.ccart-item, tr');
        var span = ci && (ci.querySelector('.ccart-qty span') || ci.querySelector('.qty span'));
        var cur = span ? (parseInt(span.textContent, 10) || 1) : 1;
        var next = cur + delta;
        if(next < 1){                                   /* minus at qty 1 → remove the line */
          if(ci) ci.classList.add('ci-out');
          schedQty(key, 0, 200);
          return;
        }
        if(span){ span.textContent = next; span.classList.remove('val-pulse'); void span.offsetWidth; span.classList.add('val-pulse'); }
        schedQty(key, next, 340);
      }
      var add = e.target.closest('.js-add');
      if(add && !add.disabled){
        e.preventDefault();
        var id = add.dataset.id;
        if(!id) return;
        /* "Added ✓" flash, matching the mock — only for recommendation-rail
           adds (.ccart-rec-add), which stay in place after adding rather
           than navigating anywhere. */
        var isRec = add.classList.contains('ccart-rec-add');
        var origLabel = isRec ? add.textContent : null;
        /* Locked while the request is in flight so a double tap can't add two
           (audit JSC-09); released below unless the "Added ✓" flash owns it. */
        add.disabled = true;
        var release = function(){ if(add.isConnected && !add.classList.contains('is-added')) add.disabled = false; };
        CN.addToCart(id, 1, CN.cartImgFor(add)).then(function(res){
          if(!(res && isRec && add.isConnected)){ release(); return; }
          if(res && isRec && add.isConnected){
            add.textContent = 'Added ✓';
            add.classList.add('is-added');
            add.disabled = true;
            setTimeout(function(){
              if(!add.isConnected) return;
              add.textContent = origLabel;
              add.classList.remove('is-added');
              add.disabled = false;
            }, 1400);
          }
        }, release);
      }
      var addAll = e.target.closest('.js-add-all');
      if(addAll && !addAll.disabled){
        e.preventDefault();
        var ids = (addAll.dataset.ids || '').split(',').map(function(s){ return s.trim(); }).filter(Boolean);
        if(!ids.length) return;
        addAll.disabled = true;
        CN.addAllToCart(ids).then(function(){ addAll.disabled = false; }).catch(function(){ addAll.disabled = false; });
      }
    });

    /* search overlay
       Consolidated into two functions rather than the previous scattered
       class.add/remove calls repeated at every trigger: it had no focus
       trap, no aria-hidden toggle (the dialog wasn't announced as one at
       all), and no return-focus on close, and the scroll-lock used to be a
       second, separate set of listeners bound to the same buttons. Same
       CN.trapFocus + remember-opener pattern as the cart drawer and Quick
       View. */
    var so = $('#searchOverlay');
    function openSearch(){
      if(!so) return;
      so.classList.add('open'); so.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';
      CN._searchReturn = document.activeElement;
      if(CN._searchUntrap) CN._searchUntrap();
      CN._searchUntrap = CN.trapFocus(so);
      setTimeout(function(){ var i=$('#searchInput'); i&&i.focus(); }, 200);
      if(CN.srOnOpen) CN.srOnOpen();
    }
    CN.closeSearch = function(){
      if(!so) return;
      so.classList.remove('open'); so.setAttribute('aria-hidden','true');
      document.body.style.overflow = '';
      if(CN._searchUntrap){ CN._searchUntrap(); CN._searchUntrap = null; }
      if(CN._searchReturn && CN._searchReturn.focus){ CN._searchReturn.focus(); CN._searchReturn = null; }
    };
    $$('.js-search-open').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); openSearch(); }); });
    var sc = $('#searchClose'); if(sc) sc.addEventListener('click', CN.closeSearch);
    if(so) so.addEventListener('click', function(e){ if(e.target===so) CN.closeSearch(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && so && so.classList.contains('open')) CN.closeSearch(); });

    /* ---------- search: predictive dropdown + discovery (rebuilt 2026-10-06) ----------
       One engine for the search overlay (phones, and the search button) and
       the desktop header box.
       While typing: Shopify's predictive API (products, categories, suggested
       searches). If it finds no products, the full store search is asked
       through the search-data section (it catches words the predictive API
       misses, e.g. "phone"); if that is empty too, words that point at a
       category ("neck pain" -> Wellness & Recovery) show that category's
       products, otherwise best sellers — never a dead end.
       Before typing: recent searches, recently viewed, and Shopify's related
       products for the last product viewed (or best sellers). All history is
       this device's own localStorage; nothing personal is sent anywhere.
       Every value painted goes through cnEsc (SEC-16); only the newest query
       may paint (JSC-11). */
    (function(){
      var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var cats = [];
      try{ cats = JSON.parse(($('#srCats') || {}).textContent || '[]') || []; }catch(e){ cats = []; }
      var ALIAS = {
        'wellness-recovery': ['health','wellness','recovery','massage','massager','pain','relax','relief','muscle','fitness','gym','body','neck','back','shoulder','spa'],
        'kitchen-cafe':      ['kitchen','cafe','coffee','cook','cooking','chop','chopper','appliance','appliances','milk','tea','food'],
        'home-cleaning':     ['home','clean','cleaning','water','laundry','shoe','shoes','house'],
        'car-care-auto':     ['car','auto','vehicle','bike','wash','washer','drive','driving'],
        'tech-travel':       ['tech','travel','gadget','gadgets','charger','charging','phone','mobile','usb'],
        'hair-beauty':       ['hair','beauty','personal','grooming','skin','women','shave','shaver','scalp','makeup']
      };
      var SKEY = 'cn-searches';
      function getSearches(){ try{ return JSON.parse(localStorage.getItem(SKEY)) || []; }catch(e){ return []; } }
      function saveSearch(q){
        q = (q || '').trim(); if(q.length < 2) return;
        var l = getSearches().filter(function(x){ return x.toLowerCase() !== q.toLowerCase(); });
        l.unshift(q.slice(0, 60));
        try{ localStorage.setItem(SKEY, JSON.stringify(l.slice(0, 6))); }catch(e){}
      }

      var cache = {};
      function cached(url, make){
        if(!cache[url]) cache[url] = make().catch(function(err){ delete cache[url]; throw err; });
        return cache[url];
      }
      function getJSON(url){ return cached(url, function(){ return fetch(url, { headers: { Accept: 'application/json' } }).then(function(r){ if(!r.ok) throw new Error(r.status); return r.json(); }); }); }
      function getSD(path){
        var url = ROOT + path + (path.indexOf('?') > -1 ? '&' : '?') + 'section_id=search-data';
        return cached(url, function(){
          return fetch(url).then(function(r){ if(!r.ok) throw new Error(r.status); return r.text(); }).then(function(h){
            var m = h.match(/data-search-data>([\s\S]*?)<\/script>/);
            return (m ? JSON.parse(m[1]) : []).map(function(p){ return { t:p.title, u:p.url, h:p.handle, img:p.img, p:p.price, c:p.compare }; });
          });
        });
      }
      function isGift(h){ return (h || '').indexOf('free-surprise-gift') > -1; }
      function fromSuggest(list){
        return (list || []).filter(function(p){ return !isGift(p.handle || p.url); }).map(function(p){
          var im = p.image || (p.featured_image && p.featured_image.url) || '';
          if(im) im += (im.indexOf('?') > -1 ? '&' : '?') + 'width=160';
          var cmp = parseFloat(p.compare_at_price_max || p.compare_at_price_min || 0);
          return { t:p.title, u:p.url, h:p.handle, img:im, p:Math.round(parseFloat(p.price || 0) * 100), c:Math.round(cmp * 100) };
        });
      }
      function words(q){ return q.toLowerCase().split(/[^a-z0-9]+/).filter(function(w){ return w.length >= 3; }); }
      function catMatches(q){
        var ws = words(q); if(!ws.length) return [];
        return cats.filter(function(c){
          var toks = words(c.t).concat(ALIAS[c.h] || []);
          return ws.some(function(w){ return toks.some(function(tk){ return tk.indexOf(w) === 0 || w.indexOf(tk) === 0; }); });
        });
      }
      function hl(text, q){
        var ws = q.toLowerCase().split(/\s+/).filter(function(w){ return w.length >= 2; })
          .map(function(w){ return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
        if(!ws.length) return cnEsc(text);
        var re = new RegExp('(' + ws.join('|') + ')', 'ig');
        return String(text).split(re).map(function(part, i){ return i % 2 ? '<mark>' + cnEsc(part) + '</mark>' : cnEsc(part); }).join('');
      }
      function itemHTML(p, q){
        var off = p.p != null && p.c > p.p ? Math.round((p.c - p.p) * 100 / p.c) : 0;
        return '<a class="sr-item" data-sr-item href="' + cnEsc(p.u) + '">' +
          '<span class="sr-th">' + (p.img ? '<img src="' + cnEsc(p.img) + '" alt="" width="48" height="48" loading="lazy">' : '') + '</span>' +
          '<span class="sr-meta"><b>' + (q ? hl(p.t, q) : cnEsc(p.t)) + '</b>' +
          (p.p == null ? '' : '<small><span class="sr-pr">' + CN.money(p.p) + '</span>' + (off ? ' <s>' + CN.money(p.c) + '</s> <em>' + off + '% off</em>' : '') + '</small>') +
          '</span></a>';
      }
      function chips(list, attr){
        return '<div class="sr-chips">' + list.map(function(x){
          return attr === 'q' ? '<button type="button" class="sr-chip" data-sr-item data-q="' + cnEsc(x) + '">' + cnEsc(x) + '</button>'
                              : '<a class="sr-chip" data-sr-item href="' + cnEsc(x.u) + '">' + cnEsc(x.t) + '</a>';
        }).join('') + '</div>';
      }
      function sec(title, body, extra){ return '<div class="sr-sec"><div class="sr-h"><span>' + title + '</span>' + (extra || '') + '</div>' + body + '</div>'; }

      /* q -> { prods, colls, queries, note } */
      function lookup(q){
        var enc = encodeURIComponent(q);
        var local = catMatches(q);
        var fullP = getSD('search?q=' + enc + '&type=product&options[prefix]=last').catch(function(){ return []; });
        return getJSON(ROOT + 'search/suggest.json?q=' + enc + '&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each')
          .catch(function(){ return {}; })
          .then(function(d){
            var r = (d && d.resources && d.resources.results) || {};
            var prods = fromSuggest(r.products);
            var colls = (r.collections || []).map(function(c){ return { t:c.title, u:c.url }; });
            local.forEach(function(c){ if(!colls.some(function(x){ return x.u === c.u; })) colls.push(c); });
            colls = colls.slice(0, 4);
            var queries = (r.queries || []).map(function(x){ return x.text; })
              .filter(function(t){ return t && t.toLowerCase() !== q.toLowerCase(); }).slice(0, 4);
            var out = { prods: prods, colls: colls, queries: queries, note: '' };
            if(prods.length) return out;
            return fullP.then(function(list){
              if(list.length){ out.prods = list.slice(0, 6); return out; }
              var via = local[0];
              var path = via ? via.u.replace(/^\//, '') : 'collections/all?sort_by=best-selling';
              return getSD(path).catch(function(){ return []; }).then(function(l){
                out.prods = l.slice(0, via ? 6 : 4);
                out.note = 'No exact match for “' + cnEsc(q) + '”' + (via ? ' — you might like these from ' + cnEsc(via.t) : ' — popular right now');
                return out;
              });
            });
          });
      }
      function resultsHTML(q, res){
        var html = '';
        if(res.note) html += '<p class="sr-note">' + res.note + '</p>';
        if(res.prods.length) html += sec(res.note ? 'Products' : 'Products', res.prods.map(function(p){ return itemHTML(p, res.note ? '' : q); }).join(''));
        if(res.colls.length) html += sec('Categories', chips(res.colls));
        if(res.queries.length) html += sec('Try searching', chips(res.queries, 'q'));
        html += '<a class="sr-all" data-sr-item href="' + ROOT + 'search?q=' + encodeURIComponent(q) + '&type=product">See all results for “' + cnEsc(q) + '” <span aria-hidden="true">→</span></a>';
        return html;
      }

      /* before typing */
      function discoverHTML(withCats){
        var html = '';
        var rs = getSearches();
        if(rs.length) html += sec('Recent searches', chips(rs.slice(0, 5), 'q'), '<button type="button" class="sr-clear" data-sr-clear>Clear</button>');
        if(withCats && cats.length) html += sec('Shop by category', chips(cats));
        var seen = (CN.getRecent ? CN.getRecent() : []).filter(function(x){ return x && x.url && !isGift(x.handle); });
        var here = location.pathname.replace(/\/$/, '');
        var viewed = seen.filter(function(x){ return x.url.split('?')[0] !== here; }).slice(0, 4);
        if(viewed.length) html += sec('Recently viewed', '<div class="sr-rail">' + viewed.map(function(x){
          var im = x.image ? (String(x.image).indexOf('//') === 0 ? 'https:' + x.image : x.image) : '';
          return itemHTML({ t:x.title, u:x.url, img:im, p:null, c:0 }, '');
        }).join('') + '</div>');
        html += '<div data-sr-reco></div>';
        return html;
      }
      function fillReco(box){
        var slot = box.querySelector('[data-sr-reco]');
        if(!slot) return;
        var seen = (CN.getRecent ? CN.getRecent() : []).filter(function(x){ return x && x.handle && !isGift(x.handle); });
        var here = location.pathname.replace(/\/$/, '');
        var skip = seen.filter(function(x){ return x.url.split('?')[0] !== here; }).slice(0, 4).map(function(x){ return x.handle; });
        seen.forEach(function(x){ if(x.url.split('?')[0] === here) skip.push(x.handle); });
        var src;
        if(seen.length){
          var last = seen[0];
          var idP = last.id ? Promise.resolve(last.id) : getJSON(ROOT + 'products/' + encodeURIComponent(last.handle) + '.js').then(function(p){ return p.id; });
          src = idP.then(function(id){ return getSD('recommendations/products?product_id=' + id + '&limit=8&intent=related'); })
                   .then(function(l){ return { title:'Recommended for you', list:l }; });
        } else {
          src = getSD('collections/all?sort_by=best-selling').then(function(l){ return { title:'Popular right now', list:l }; });
        }
        src.then(function(r){
          var list = r.list.filter(function(p){ return skip.indexOf(p.h) === -1; }).slice(0, 4);
          if(!list.length && r.title !== 'Popular right now') return getSD('collections/all?sort_by=best-selling').then(function(l){ return { title:'Popular right now', list:l.filter(function(p){ return skip.indexOf(p.h) === -1; }).slice(0, 4) }; });
          return { title:r.title, list:list };
        }).then(function(r){
          if(r && r.list.length && slot.isConnected) slot.outerHTML = sec(r.title, '<div class="sr-rail">' + r.list.map(function(p){ return itemHTML(p, ''); }).join('') + '</div>');
        }).catch(function(){});
      }

      /* wire one input + its result box */
      function attach(input, box, opts){
        if(!input || !box) return;
        var t = 0, seq = 0, active = -1;
        function items(){ return [].slice.call(box.querySelectorAll('[data-sr-item]')); }
        function setActive(i){
          var list = items(); if(!list.length){ active = -1; return; }
          active = (i + list.length) % list.length;
          list.forEach(function(el, k){ el.classList.toggle('is-active', k === active); });
          list[active].scrollIntoView({ block: 'nearest' });
        }
        function showDiscover(){
          active = -1;
          box.classList.remove('sr-busy');
          if(opts.onTyping) opts.onTyping(false);
          var target = opts.discoverBox || box;
          if(opts.discoverBox) box.innerHTML = '';
          target.innerHTML = discoverHTML(!opts.discoverBox);
          fillReco(target);
          if(opts.show) opts.show(!!target.textContent.trim() || !!target.querySelector('[data-sr-reco]'));
        }
        function run(){
          clearTimeout(t);
          var q = input.value.trim();
          var mine = ++seq; active = -1;
          if(q.length < 2){ showDiscover(); return; }
          if(opts.onTyping) opts.onTyping(true);
          if(opts.discoverBox) opts.discoverBox.innerHTML = '';
          t = setTimeout(function(){
            if(!box.innerHTML.trim()) box.innerHTML = '<p class="sr-note">Searching…</p>';
            box.classList.add('sr-busy');
            if(opts.show) opts.show(true);
            lookup(q).then(function(res){
              if(mine !== seq) return;
              box.classList.remove('sr-busy');
              if(opts.show) opts.show(true);
              box.innerHTML = resultsHTML(q, res);
            }).catch(function(){
              if(mine !== seq) return;
              box.classList.remove('sr-busy');
              if(opts.show) opts.show(true);
              box.innerHTML = '<p class="sr-note">Press Enter to search for “' + cnEsc(q) + '”.</p>';
            });
          }, 200);
        }
        input.addEventListener('input', run);
        input.addEventListener('keydown', function(e){
          if(e.key === 'ArrowDown'){ e.preventDefault(); setActive(active + 1); }
          else if(e.key === 'ArrowUp'){ e.preventDefault(); setActive(active - 1); }
          else if(e.key === 'Enter' && active > -1){
            var el = items()[active];
            if(el){ e.preventDefault(); el.click(); }
          } else if(e.key === 'Escape' && opts.onEscape){ opts.onEscape(); }
        });
        function onClick(e){
          var qb = e.target.closest('[data-q]');
          if(qb){ e.preventDefault(); input.value = qb.getAttribute('data-q'); input.focus(); run(); return; }
          if(e.target.closest('[data-sr-clear]')){
            e.preventDefault();
            try{ localStorage.removeItem(SKEY); }catch(err){}
            showDiscover(); input.focus(); return;
          }
          var a = e.target.closest('a[href]');
          if(a) saveSearch(input.value);
        }
        box.addEventListener('click', onClick);
        if(opts.discoverBox) opts.discoverBox.addEventListener('click', onClick);
        var form = input.form;
        if(form) form.addEventListener('submit', function(){ saveSearch(input.value); });
        return { refresh: function(){ if(input.value.trim().length < 2) showDiscover(); else run(); } };
      }

      /* overlay (phones + the search button) */
      var inner = $('#srInner');
      var ov = attach($('#searchInput'), $('#predict'), {
        discoverBox: $('#srDiscover'),
        onTyping: function(on){ if(inner) inner.classList.toggle('is-typing', on); },
        onEscape: function(){ if(CN.closeSearch) CN.closeSearch(); }
      });
      CN.srOnOpen = function(){ if(ov) ov.refresh(); };

      /* Typing placeholder (owner 2026-10-06): the empty search boxes type out
         real product types ("Search massage gun", erase, "Search car
         vacuum"…), from #srTypes so new products join by themselves. Runs
         only while the box is on screen and empty (the placeholder is hidden
         once the shopper types), pauses in background tabs, and is off for
         reduced motion — the normal placeholder stays. */
      (function(){
        var terms = [];
        try{ terms = JSON.parse(($('#srTypes') || {}).textContent || '[]') || []; }catch(e){ terms = []; }
        if(terms.length < 2 || CN.reduceMotion()) return;
        var meas = document.createElement('canvas').getContext('2d');
        /* What fits this box: "Search electric toothbrush", else the bare
           name; a name that does not fit whole is skipped (half a name like
           "accessory" means nothing). The header box is 220px on most
           desktops but much narrower at 1024px, where only short names run. */
        function label(input, term){
          var cs = getComputedStyle(input);
          meas.font = cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
          var room = input.clientWidth - 6;
          function fits(s){ return meas.measureText(s).width <= room; }
          if(fits('Search ' + term)) return { pre: 'Search ', body: term };
          return fits(term) ? { pre: '', body: term } : null;
        }
        function typewriter(input, isVisible){
          if(!input) return;
          var i = Math.floor(Math.random() * terms.length), ch = 0, deleting = false, cur = null;
          function set(n){ input.setAttribute('placeholder', cur.pre + cur.body.slice(0, n)); }
          function tick(){
            if(input.value || document.hidden || !isVisible()){ setTimeout(tick, 800); return; }
            if(!cur){
              for(var k = 0; k < terms.length && !cur; k++){ cur = label(input, terms[i % terms.length]); if(!cur) i++; }
              if(!cur){ setTimeout(tick, 2000); return; }      /* nothing fits this box (yet) */
            }
            var term = cur.body;
            if(!deleting){
              ch = Math.min(ch + 1, term.length); set(ch);
              if(ch >= term.length){ deleting = true; setTimeout(tick, 1700); return; }
              setTimeout(tick, 80);
            } else {
              ch = Math.max(ch - 1, 0); set(ch);
              if(ch <= 0){ deleting = false; i++; cur = null; setTimeout(tick, 380); return; }
              setTimeout(tick, 35);
            }
          }
          setTimeout(tick, 900);
        }
        var ovEl = $('#searchOverlay');
        typewriter($('#searchInput'), function(){ return !!(ovEl && ovEl.classList.contains('open')); });
        var hEl = $('#hSearch');
        typewriter(hEl, function(){ return !!(hEl && hEl.offsetParent); });
      })();

      /* desktop header box */
      var hs = $('#hSearch'), hr = $('#hResults');
      if(hs && hr){
        var hd = attach(hs, hr, {
          show: function(on){ hr.hidden = !on; },
          onEscape: function(){ hr.hidden = true; hs.blur(); }
        });
        hs.addEventListener('focus', function(){ if(hd) hd.refresh(); });
        document.addEventListener('click', function(e){ if(!e.target.closest('.hsearch')) hr.hidden = true; });
      }
    })();

    /* mobile nav — background scroll-lock, Escape-to-close and a lightweight
       focus trap so the open drawer behaves like a real dialog. The drawer is
       its own element (#mobileNav), not the desktop <ul> restyled, so nothing
       here has to reason about which layout is on screen. */
    var burger = $('#burger'), mnav = $('#mobileNav'), mscrim = $('#mnavScrim');
    if(burger && mnav){
      /* NB: the drawer is CSS-positioned under the nav bar via top:78px. That
         offset is relative to .header (its backdrop-filter makes it the
         containing block for this position:fixed panel), so it already sits
         flush under the bar at every scroll position — no JS offset needed. */
      mnav.hidden = false;               /* [hidden] was only the pre-JS fallback */
      if(mscrim) mscrim.hidden = false;

      function collapseGroups(){
        $$('.mnav-group', mnav).forEach(function(g){
          g.classList.remove('open');
          var b = g.querySelector('.mnav-group-btn');
          if(b) b.setAttribute('aria-expanded', 'false');
        });
      }
      CN.closeNav = function(){
        mnav.classList.remove('open');
        if(mscrim) mscrim.classList.remove('open');
        burger.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        /* Reset to all-collapsed so the drawer always reopens at the top level
           rather than restoring whatever was expanded two pages ago. */
        collapseGroups();
      };
      burger.addEventListener('click', function(){
        var open = !mnav.classList.contains('open');
        mnav.classList.toggle('open', open);
        if(mscrim) mscrim.classList.toggle('open', open);
        burger.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', open);
        document.body.style.overflow = open ? 'hidden' : '';
        if(!open) collapseGroups();
        if(open){ var first = mnav.querySelector('a,button'); if(first){ setTimeout(function(){ first.focus(); }, 60); } }
      });
      if(mscrim) mscrim.addEventListener('click', function(){ CN.closeNav(); });

      /* Accordion — one group open at a time keeps the drawer short enough that
         the category list never scrolls out from under the thumb. */
      mnav.addEventListener('click', function(e){
        var btn = e.target.closest('.mnav-group-btn');
        if(btn){
          var group = btn.closest('.mnav-group');
          var willOpen = !group.classList.contains('open');
          collapseGroups();
          group.classList.toggle('open', willOpen);
          btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          return;
        }
        /* close when a real link is tapped (but not on empty drawer space) */
        if(e.target.closest('a')) CN.closeNav();
      });

      /* trap Tab within the drawer while it's open */
      mnav.addEventListener('keydown', function(e){
        if(e.key !== 'Tab' || !mnav.classList.contains('open')) return;
        var f = $$('a,button', mnav).filter(function(el){ return el.offsetParent !== null; });
        if(!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
        else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
      });
    }

    /* escape closes any open overlay/menu */
    document.addEventListener('keydown', function(e){
      if(e.key==='Escape'){
        CN.closeCart();
        if(so && so.classList.contains('open')) CN.closeSearch();
        if(mnav && mnav.classList.contains('open')){ CN.closeNav(); burger.focus(); }
      }
    });

    /* reveal on scroll — position-based so content can never get stuck hidden */
    var revealEls = $$('.reveal');
    function cnReveal(){
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for(var i = revealEls.length - 1; i >= 0; i--){
        if(revealEls[i].getBoundingClientRect().top < vh * 0.92){
          revealEls[i].classList.add('in');
          revealEls.splice(i, 1);
        }
      }
    }
    cnReveal();
    var revTick = false;
    window.addEventListener('scroll', function(){ if(revTick) return; revTick = true; requestAnimationFrame(function(){ revTick = false; cnReveal(); }); }, { passive: true });
    window.addEventListener('resize', cnReveal, { passive: true });
    window.addEventListener('load', cnReveal);

    CN.fetchCart();
    CN.restoreCartFromLink();
  });

  /* re-render cart drawer when theme editor loads sections */
  document.addEventListener('shopify:section:load', function(){ CN.fetchCart(); });
})();
